/* Translation of en-US.ts. Same keys, in the same order; only the
 * values are translated, and every {{placeholder}} is kept. */
export const notifications = {
  "types": {
    "feature_request_update": {
      "status": {
        "title": "Votre demande de fonctionnalité est {{featureStatus}}",
        "body": "« {{request}} » est {{featureStatus}}."
      },
      "reply": {
        "title": "Réponse à votre demande de fonctionnalité",
        "body": "« {{request}} » : {{reply}}"
      },
      "merged": {
        "title": "Déjà demandé",
        "body": "« {{request}} » a déjà été demandé. Nous avons ajouté votre vote."
      }
    },
    "feature_idea_update": {
      "default": {
        "title": "Une idée pour laquelle vous avez voté est {{featureStatus}}",
        "body": "« {{idea}} » est {{featureStatus}}."
      }
    },
    "work_change_opened": {
      "default": {
        "title": "L’intervention est en cours de modification",
        "body": "{{actor}} modifie « {{job}} ». Il vous sera demandé de l’accepter à nouveau."
      }
    },
    "work_changed": {
      "default": {
        "title": "L’intervention a changé. Acceptez-la à nouveau",
        "body": "{{actor}} a modifié « {{job}} » : {{changes}}. Vérifiez-la et acceptez-la à nouveau."
      }
    },
    "quote_scope_changed": {
      "default": {
        "title": "Le périmètre que vous chiffriez a changé",
        "body": "{{actor}} a modifié « {{job}} » : {{changes}}. Chiffrez à nouveau le nouveau périmètre."
      }
    },
    "work_accepted_longer": {
      "default": {
        "title": "Acceptée, et elle prend maintenant plus de temps",
        "body": "{{actor}} a accepté « {{job}} » et a maintenant besoin de {{minutes}} minutes. Vérifiez la date d’échéance."
      }
    },
    "quote_accepted": {
      "noJob": {
        "title": "Votre devis a été accepté",
        "body": "Votre devis pour une intervention a été accepté. Le travail est pour vous."
      },
      "default": {
        "title": "Votre devis a été accepté",
        "body": "Votre devis pour « {{job}} » a été accepté. Le travail est pour vous."
      }
    },
    "asset_request_job_assigned": {
      "noActor": {
        "title": "Intervention attribuée",
        "body": "L’équipe a confié l’intervention pour {{request}} à {{assignee}}."
      },
      "default": {
        "title": "Intervention attribuée",
        "body": "{{actor}} a confié l’intervention pour {{request}} à {{assignee}}."
      }
    },
    "asset_request_job_accepted": {
      "noActor": {
        "title": "Intervention acceptée",
        "body": "L’équipe a accepté l’intervention pour {{request}}."
      },
      "default": {
        "title": "Intervention acceptée",
        "body": "{{actor}} a accepté l’intervention pour {{request}}."
      }
    },
    "asset_request_job_declined": {
      "noActor": {
        "title": "Intervention refusée",
        "body": "L’équipe ne peut pas prendre l’intervention pour {{request}}. L’équipe va trouver quelqu’un d’autre."
      },
      "default": {
        "title": "Intervention refusée",
        "body": "{{actor}} ne peut pas prendre l’intervention pour {{request}}. L’équipe va trouver quelqu’un d’autre."
      }
    },
    "asset_request_job_verified": {
      "noActor": {
        "title": "Travail vérifié",
        "body": "L’équipe a vérifié le travail réalisé pour {{request}}."
      },
      "default": {
        "title": "Travail vérifié",
        "body": "{{actor}} a vérifié le travail réalisé pour {{request}}."
      }
    },
    "asset_request_inspection_approved": {
      "noActor": {
        "title": "Inspection validée",
        "body": "L’équipe a validé l’inspection pour {{request}}."
      },
      "default": {
        "title": "Inspection validée",
        "body": "{{actor}} a validé l’inspection pour {{request}}."
      }
    },
    "asset_request_submitted": {
      "noActor": {
        "title": "Une demande a été créée pour vous",
        "body": "L’équipe a créé « {{request}} » pour vous sur {{asset}}."
      },
      "default": {
        "title": "Une demande a été créée pour vous",
        "body": "{{actor}} a créé « {{request}} » pour vous sur {{asset}}."
      }
    },
    "job_started": {
      "noActor": {
        "title": "Intervention commencée",
        "body": "L’assigné a commencé « {{job}} »."
      },
      "default": {
        "title": "Intervention commencée",
        "body": "{{actor}} a commencé « {{job}} »."
      }
    },
    "job_paused": {
      "noActorReason": {
        "title": "Intervention en pause",
        "body": "L’assigné a mis « {{job}} » en pause. {{reason}}"
      },
      "noActor": {
        "title": "Intervention en pause",
        "body": "L’assigné a mis « {{job}} » en pause."
      },
      "reason": {
        "title": "Intervention en pause",
        "body": "{{actor}} a mis « {{job}} » en pause. {{reason}}"
      },
      "default": {
        "title": "Intervention en pause",
        "body": "{{actor}} a mis « {{job}} » en pause."
      }
    },
    "job_resumed": {
      "noActor": {
        "title": "Intervention reprise",
        "body": "L’assigné a repris « {{job}} »."
      },
      "default": {
        "title": "Intervention reprise",
        "body": "{{actor}} a repris « {{job}} »."
      }
    },
    "job_evidence_added": {
      "noActor": {
        "title": "Justificatifs ajoutés",
        "body": "L’assigné a ajouté les justificatifs demandés pour « {{job}} ». Vérifiez-les pour clôturer l’intervention."
      },
      "default": {
        "title": "Justificatifs ajoutés",
        "body": "{{actor}} a ajouté les justificatifs demandés pour « {{job}} ». Vérifiez-les pour clôturer l’intervention."
      }
    },
    "inspection_cancelled": {
      "noActorNoAssetReason": {
        "title": "Inspection annulée",
        "body": "Un collègue a annulé l’inspection sur un actif. {{reason}}"
      },
      "noActorNoAsset": {
        "title": "Inspection annulée",
        "body": "Un collègue a annulé l’inspection sur un actif."
      },
      "noActorReason": {
        "title": "Inspection annulée",
        "body": "Un collègue a annulé l’inspection sur {{asset}}. {{reason}}"
      },
      "noActor": {
        "title": "Inspection annulée",
        "body": "Un collègue a annulé l’inspection sur {{asset}}."
      },
      "reason": {
        "title": "Inspection annulée",
        "body": "{{actor}} a annulé l’inspection sur {{asset}}. {{reason}}"
      },
      "default": {
        "title": "Inspection annulée",
        "body": "{{actor}} a annulé l’inspection sur {{asset}}."
      }
    },
    "asset_collaboration_shared": {
      "noAsset": {
        "title": "Un actif a été partagé avec vous",
        "body": "Actif — ouvrez-le pour examiner et accepter l’accès."
      },
      "default": {
        "title": "Un actif a été partagé avec vous",
        "body": "{{asset}} — ouvrez-le pour examiner et accepter l’accès."
      }
    },
    "asset_in_service": {
      "backNoAsset": {
        "title": "Actif remis en service",
        "body": "Un actif est en service. Les plannings reprennent à partir d’aujourd’hui. {{note}}"
      },
      "backNoAssetNoNote": {
        "title": "Actif remis en service",
        "body": "Un actif est en service. Les plannings reprennent à partir d’aujourd’hui."
      },
      "firstNoAsset": {
        "title": "Actif mis en service",
        "body": "Un actif est en service. Les plannings reprennent à partir d’aujourd’hui. {{note}}"
      },
      "firstNoAssetNoNote": {
        "title": "Actif mis en service",
        "body": "Un actif est en service. Les plannings reprennent à partir d’aujourd’hui."
      },
      "back": {
        "title": "Actif remis en service",
        "body": "{{asset}} est en service. Les plannings reprennent à partir d’aujourd’hui. {{note}}"
      },
      "backNoNote": {
        "title": "Actif remis en service",
        "body": "{{asset}} est en service. Les plannings reprennent à partir d’aujourd’hui."
      },
      "first": {
        "title": "Actif mis en service",
        "body": "{{asset}} est en service. Les plannings reprennent à partir d’aujourd’hui. {{note}}"
      },
      "firstNoNote": {
        "title": "Actif mis en service",
        "body": "{{asset}} est en service. Les plannings reprennent à partir d’aujourd’hui."
      }
    },
    "asset_out_of_service": {
      "noAsset": {
        "title": "Actif hors service",
        "body": "Un actif est hors service ({{reason}}). Ses plannings sont en pause jusqu’à sa remise en service. {{note}}"
      },
      "noAssetNoNote": {
        "title": "Actif hors service",
        "body": "Un actif est hors service ({{reason}}). Ses plannings sont en pause jusqu’à sa remise en service."
      },
      "noAssetNoReason": {
        "title": "Actif hors service",
        "body": "Un actif est hors service. Ses plannings sont en pause jusqu’à sa remise en service. {{note}}"
      },
      "noAssetNoReasonNoNote": {
        "title": "Actif hors service",
        "body": "Un actif est hors service. Ses plannings sont en pause jusqu’à sa remise en service."
      },
      "default": {
        "title": "Actif hors service",
        "body": "{{asset}} est hors service ({{reason}}). Ses plannings sont en pause jusqu’à sa remise en service. {{note}}"
      },
      "noNote": {
        "title": "Actif hors service",
        "body": "{{asset}} est hors service ({{reason}}). Ses plannings sont en pause jusqu’à sa remise en service."
      },
      "noReason": {
        "title": "Actif hors service",
        "body": "{{asset}} est hors service. Ses plannings sont en pause jusqu’à sa remise en service. {{note}}"
      },
      "noReasonNoNote": {
        "title": "Actif hors service",
        "body": "{{asset}} est hors service. Ses plannings sont en pause jusqu’à sa remise en service."
      }
    },
    "asset_owner_assigned": {
      "default": {
        "title": "Nouvel actif sous votre responsabilité",
        "body": "{{asset}} est désormais sous votre responsabilité."
      }
    },
    "asset_owner_removed": {
      "default": {
        "title": "Responsabilité d’actif modifiée",
        "body": "{{asset}} n’est plus sous votre responsabilité."
      }
    },
    "asset_request_approved": {
      "noAsset": {
        "title": "Votre demande a été approuvée",
        "body": "« {{request}} » a été approuvée pour l’actif."
      },
      "default": {
        "title": "Votre demande a été approuvée",
        "body": "« {{request}} » a été approuvée pour {{asset}}."
      },
      "withNote": {
        "title": "Votre demande a été approuvée",
        "body": "« {{request}} » a été approuvée : {{note}}"
      }
    },
    "asset_request_awaiting_customer": {
      "noAsset": {
        "title": "Action requise sur votre demande",
        "body": "{{request}} attend une réponse de votre part pour l’actif."
      },
      "default": {
        "title": "Action requise sur votre demande",
        "body": "{{request}} attend une réponse de votre part pour {{asset}}."
      },
      "note": {
        "title": "Action requise sur votre demande",
        "body": "{{note}}"
      }
    },
    "asset_request_closed": {
      "byActor": {
        "title": "Dossier clôturé — tout le travail est terminé",
        "body": "{{actor}} a vérifié le dernier travail de {{request}}. Tout a été réalisé et accepté."
      },
      "default": {
        "title": "Dossier clôturé — tout le travail est terminé",
        "body": "{{request}} : tout a été réalisé et accepté. Plus rien à faire."
      },
      "operatorClosed": {
        "title": "Votre demande a été clôturée",
        "body": "{{request}} a été marquée comme terminée."
      }
    },
    "asset_request_commented": {
      "requesterNoRequestPhotoLegacy": {
        "title": "Nouveau message",
        "body": "Le demandeur a partagé une photo dans une demande."
      },
      "requesterNoRequestPhoto": {
        "title": "Nouveau message",
        "body": "Le demandeur a partagé une photo dans une demande."
      },
      "teamNoRequestPhotoLegacy": {
        "title": "Nouveau message",
        "body": "L’équipe a partagé une photo dans une demande."
      },
      "teamNoRequestPhoto": {
        "title": "Nouveau message",
        "body": "L’équipe a partagé une photo dans une demande."
      },
      "requesterPhoto": {
        "title": "Nouveau message",
        "body": "Le demandeur a partagé une photo dans « {{request}} »."
      },
      "noRequestPhotoLegacy": {
        "title": "Nouveau message",
        "body": "{{author}} a partagé une photo dans une demande."
      },
      "noRequestPhoto": {
        "title": "Nouveau message",
        "body": "{{author}} a partagé une photo dans une demande."
      },
      "teamPhoto": {
        "title": "Nouveau message",
        "body": "L’équipe a partagé une photo dans « {{request}} »."
      },
      "requesterNoRequestLegacy": {
        "title": "Nouveau message",
        "body": "Le demandeur, dans une demande : {{message}}"
      },
      "requesterNoRequest": {
        "title": "Nouveau message",
        "body": "Le demandeur, dans une demande : {{message}}"
      },
      "teamNoRequestLegacy": {
        "title": "Nouveau message",
        "body": "L’équipe, dans une demande : {{message}}"
      },
      "teamNoRequest": {
        "title": "Nouveau message",
        "body": "L’équipe, dans une demande : {{message}}"
      },
      "photo": {
        "title": "Nouveau message",
        "body": "{{author}} a partagé une photo dans « {{request}} »."
      },
      "requester": {
        "title": "Nouveau message",
        "body": "Le demandeur, dans « {{request}} » : {{message}}"
      },
      "noRequestLegacy": {
        "title": "Nouveau message",
        "body": "{{author}}, dans une demande : {{message}}"
      },
      "noRequest": {
        "title": "Nouveau message",
        "body": "{{author}}, dans une demande : {{message}}"
      },
      "team": {
        "title": "Nouveau message",
        "body": "L’équipe, dans « {{request}} » : {{message}}"
      },
      "default": {
        "title": "Nouveau message",
        "body": "{{author}}, dans « {{request}} » : {{message}}"
      }
    },
    "asset_request_completion_accepted": {
      "verifierNoRequesterNoRequestLegacy": {
        "title": "Le demandeur est satisfait — vérifiez pour clôturer",
        "body": "Le demandeur a accepté le travail réalisé sur la demande. Vérifiez l’intervention pour la clôturer."
      },
      "verifierNoRequesterNoRequest": {
        "title": "Le demandeur est satisfait — vérifiez pour clôturer",
        "body": "Le demandeur a accepté le travail réalisé sur la demande. Vérifiez l’intervention pour la clôturer."
      },
      "verifierNoRequester": {
        "title": "Le demandeur est satisfait — vérifiez pour clôturer",
        "body": "Le demandeur a accepté le travail réalisé sur « {{request}} ». Vérifiez l’intervention pour la clôturer."
      },
      "verifierNoRequestLegacy": {
        "title": "Le demandeur est satisfait — vérifiez pour clôturer",
        "body": "{{requester}} a accepté le travail réalisé sur la demande. Vérifiez l’intervention pour la clôturer."
      },
      "verifierNoRequest": {
        "title": "Le demandeur est satisfait — vérifiez pour clôturer",
        "body": "{{requester}} a accepté le travail réalisé sur la demande. Vérifiez l’intervention pour la clôturer."
      },
      "verifier": {
        "title": "Le demandeur est satisfait — vérifiez pour clôturer",
        "body": "{{requester}} a accepté le travail réalisé sur « {{request}} ». Vérifiez l’intervention pour la clôturer."
      },
      "informedNoRequesterNoRequestLegacy": {
        "title": "Le demandeur a accepté le travail",
        "body": "Le demandeur a accepté le travail réalisé sur la demande."
      },
      "informedNoRequesterNoRequest": {
        "title": "Le demandeur a accepté le travail",
        "body": "Le demandeur a accepté le travail réalisé sur la demande."
      },
      "informedNoRequester": {
        "title": "Le demandeur a accepté le travail",
        "body": "Le demandeur a accepté le travail réalisé sur « {{request}} »."
      },
      "informedNoRequestLegacy": {
        "title": "Le demandeur a accepté le travail",
        "body": "{{requester}} a accepté le travail réalisé sur la demande."
      },
      "informedNoRequest": {
        "title": "Le demandeur a accepté le travail",
        "body": "{{requester}} a accepté le travail réalisé sur la demande."
      },
      "informed": {
        "title": "Le demandeur a accepté le travail",
        "body": "{{requester}} a accepté le travail réalisé sur « {{request}} »."
      }
    },
    "asset_request_completion_rejected": {
      "noActor": {
        "title": "Achèvement refusé",
        "body": "L’équipe a refusé le travail réalisé pour {{request}}. {{note}}"
      },
      "noActorNoNote": {
        "title": "Achèvement refusé",
        "body": "L’équipe a refusé le travail réalisé pour {{request}}."
      },
      "default": {
        "title": "Achèvement refusé",
        "body": "{{actor}} a refusé le travail réalisé pour {{request}}. {{note}}"
      },
      "noNote": {
        "title": "Achèvement refusé",
        "body": "{{actor}} a refusé le travail réalisé pour {{request}}."
      }
    },
    "asset_request_confirmed_schedule": {
      "requestNoRequest": {
        "title": "Date confirmée",
        "body": "Demande — le demandeur a confirmé la visite planifiée."
      },
      "visitNoInspection": {
        "title": "Visite confirmée",
        "body": "La visite pour l’inspection du {{when}} a été confirmée."
      },
      "request": {
        "title": "Date confirmée",
        "body": "{{request}} — le demandeur a confirmé la visite planifiée."
      },
      "visitNoJob": {
        "title": "Visite confirmée",
        "body": "La visite pour l’intervention du {{when}} a été confirmée."
      },
      "visit": {
        "title": "Visite confirmée",
        "body": "La visite pour {{work}} du {{when}} a été confirmée."
      }
    },
    "asset_request_converted": {
      "toInspection": {
        "title": "Votre demande a été convertie en inspection",
        "body": "{{request}} est désormais planifiée dans le travail opérationnel."
      },
      "toJob": {
        "title": "Votre demande a été convertie en intervention",
        "body": "{{request}} est désormais dans la file de travail."
      },
      "inspectionUndated": {
        "title": "Inspection planifiée",
        "body": "Une inspection est désormais prévue pour {{request}}."
      },
      "jobDue": {
        "title": "Votre demande est désormais une intervention",
        "body": "{{request}} est désormais une intervention confiée à {{assignee}}, échéance le {{dueDate}}."
      },
      "inspectionScheduled": {
        "title": "Inspection planifiée",
        "body": "{{request}} — inspection planifiée le {{scheduledWhen}}."
      },
      "jobDueNoAssignee": {
        "title": "Votre demande est désormais une intervention",
        "body": "{{request}} est désormais une intervention, échéance le {{dueDate}}."
      },
      "job": {
        "title": "Votre demande est désormais une intervention",
        "body": "{{request}} est désormais une intervention confiée à {{assignee}}."
      },
      "jobScheduled": {
        "title": "Intervention planifiée",
        "body": "{{request}} — intervention confiée à {{assignee}}, planifiée le {{scheduledDate}}."
      },
      "jobNoAssignee": {
        "title": "Votre demande est désormais une intervention",
        "body": "{{request}} est désormais une intervention."
      },
      "jobScheduledNoAssignee": {
        "title": "Intervention planifiée",
        "body": "{{request}} — intervention planifiée le {{scheduledDate}}."
      }
    },
    "asset_request_created": {
      "noAssetOperatorNoRequestPublicLinkLegacy": {
        "title": "Nouvelle demande pour un actif",
        "body": "Un opérateur a soumis une demande via le lien public."
      },
      "noAssetOperatorNoRequestPublicLink": {
        "title": "Nouvelle demande pour un actif",
        "body": "Un opérateur a soumis une demande via le lien public."
      },
      "noAssetContactNoRequestPublicLinkLegacy": {
        "title": "Nouvelle demande pour un actif",
        "body": "Un contact a soumis une demande via le lien public."
      },
      "noAssetContactNoRequestPublicLink": {
        "title": "Nouvelle demande pour un actif",
        "body": "Un contact a soumis une demande via le lien public."
      },
      "operatorNoRequestPublicLinkLegacy": {
        "title": "Nouvelle demande pour {{asset}}",
        "body": "Un opérateur a soumis une demande via le lien public."
      },
      "operatorNoRequestPublicLink": {
        "title": "Nouvelle demande pour {{asset}}",
        "body": "Un opérateur a soumis une demande via le lien public."
      },
      "contactNoRequestPublicLinkLegacy": {
        "title": "Nouvelle demande pour {{asset}}",
        "body": "Un contact a soumis une demande via le lien public."
      },
      "contactNoRequestPublicLink": {
        "title": "Nouvelle demande pour {{asset}}",
        "body": "Un contact a soumis une demande via le lien public."
      },
      "noAssetOperatorPublicLink": {
        "title": "Nouvelle demande pour un actif",
        "body": "Un opérateur a soumis « {{request}} » via le lien public."
      },
      "noAssetNoRequestPublicLinkLegacy": {
        "title": "Nouvelle demande pour un actif",
        "body": "{{submitter}} a soumis une demande via le lien public."
      },
      "noAssetNoRequestPublicLink": {
        "title": "Nouvelle demande pour un actif",
        "body": "{{submitter}} a soumis une demande via le lien public."
      },
      "noAssetContactPublicLink": {
        "title": "Nouvelle demande pour un actif",
        "body": "Un contact a soumis « {{request}} » via le lien public."
      },
      "operatorPublicLink": {
        "title": "Nouvelle demande pour {{asset}}",
        "body": "Un opérateur a soumis « {{request}} » via le lien public."
      },
      "noRequestPublicLinkLegacy": {
        "title": "Nouvelle demande pour {{asset}}",
        "body": "{{submitter}} a soumis une demande via le lien public."
      },
      "noRequestPublicLink": {
        "title": "Nouvelle demande pour {{asset}}",
        "body": "{{submitter}} a soumis une demande via le lien public."
      },
      "contactPublicLink": {
        "title": "Nouvelle demande pour {{asset}}",
        "body": "Un contact a soumis « {{request}} » via le lien public."
      },
      "noAssetPublicLink": {
        "title": "Nouvelle demande pour un actif",
        "body": "{{submitter}} a soumis « {{request}} » via le lien public."
      },
      "noAssetOperatorNoRequestLegacy": {
        "title": "Nouvelle demande pour un actif",
        "body": "Un opérateur a soumis une demande."
      },
      "noAssetOperatorNoRequest": {
        "title": "Nouvelle demande pour un actif",
        "body": "Un opérateur a soumis une demande."
      },
      "noAssetContactNoRequestLegacy": {
        "title": "Nouvelle demande pour un actif",
        "body": "Un contact a soumis une demande."
      },
      "noAssetContactNoRequest": {
        "title": "Nouvelle demande pour un actif",
        "body": "Un contact a soumis une demande."
      },
      "publicLink": {
        "title": "Nouvelle demande pour {{asset}}",
        "body": "{{submitter}} a soumis « {{request}} » via le lien public."
      },
      "operatorNoRequestLegacy": {
        "title": "Nouvelle demande pour {{asset}}",
        "body": "Un opérateur a soumis une demande."
      },
      "operatorNoRequest": {
        "title": "Nouvelle demande pour {{asset}}",
        "body": "Un opérateur a soumis une demande."
      },
      "contactNoRequestLegacy": {
        "title": "Nouvelle demande pour {{asset}}",
        "body": "Un contact a soumis une demande."
      },
      "contactNoRequest": {
        "title": "Nouvelle demande pour {{asset}}",
        "body": "Un contact a soumis une demande."
      },
      "noAssetOperator": {
        "title": "Nouvelle demande pour un actif",
        "body": "Un opérateur a soumis « {{request}} »."
      },
      "noAssetNoRequestLegacy": {
        "title": "Nouvelle demande pour un actif",
        "body": "{{submitter}} a soumis une demande."
      },
      "noAssetNoRequest": {
        "title": "Nouvelle demande pour un actif",
        "body": "{{submitter}} a soumis une demande."
      },
      "noAssetContact": {
        "title": "Nouvelle demande pour un actif",
        "body": "Un contact a soumis « {{request}} »."
      },
      "operator": {
        "title": "Nouvelle demande pour {{asset}}",
        "body": "Un opérateur a soumis « {{request}} »."
      },
      "noRequestLegacy": {
        "title": "Nouvelle demande pour {{asset}}",
        "body": "{{submitter}} a soumis une demande."
      },
      "noRequest": {
        "title": "Nouvelle demande pour {{asset}}",
        "body": "{{submitter}} a soumis une demande."
      },
      "contact": {
        "title": "Nouvelle demande pour {{asset}}",
        "body": "Un contact a soumis « {{request}} »."
      },
      "noAsset": {
        "title": "Nouvelle demande pour un actif",
        "body": "{{submitter}} a soumis « {{request}} »."
      },
      "default": {
        "title": "Nouvelle demande pour {{asset}}",
        "body": "{{submitter}} a soumis « {{request}} »."
      }
    },
    "asset_request_evidence_requested": {
      "noAsset": {
        "title": "Demande mise à jour",
        "body": "{{request}} a été mise à jour pour l’actif. {{note}}"
      },
      "noAssetNoNote": {
        "title": "Demande mise à jour",
        "body": "{{request}} a été mise à jour pour l’actif."
      },
      "default": {
        "title": "Demande mise à jour",
        "body": "{{request}} a été mise à jour pour {{asset}}. {{note}}"
      },
      "noNote": {
        "title": "Demande mise à jour",
        "body": "{{request}} a été mise à jour pour {{asset}}."
      }
    },
    "asset_request_inspection_cancelled": {
      "noActor": {
        "title": "Inspection annulée",
        "body": "L’équipe a annulé l’inspection pour {{request}}. {{note}}"
      },
      "noActorNoNote": {
        "title": "Inspection annulée",
        "body": "L’équipe a annulé l’inspection pour {{request}}."
      },
      "default": {
        "title": "Inspection annulée",
        "body": "{{actor}} a annulé l’inspection pour {{request}}. {{note}}"
      },
      "noNote": {
        "title": "Inspection annulée",
        "body": "{{actor}} a annulé l’inspection pour {{request}}."
      }
    },
    "asset_request_inspection_completed": {
      "noActor": {
        "title": "Inspection terminée",
        "body": "L’équipe a terminé l’inspection pour {{request}}. {{note}}"
      },
      "noActorNoNote": {
        "title": "Inspection terminée",
        "body": "L’équipe a terminé l’inspection pour {{request}}."
      },
      "default": {
        "title": "Inspection terminée",
        "body": "{{actor}} a terminé l’inspection pour {{request}}. {{note}}"
      },
      "noNote": {
        "title": "Inspection terminée",
        "body": "{{actor}} a terminé l’inspection pour {{request}}."
      }
    },
    "asset_request_inspection_paused": {
      "noActor": {
        "title": "Inspection en pause",
        "body": "L’équipe a mis en pause l’inspection pour {{request}}. {{note}}"
      },
      "noActorNoNote": {
        "title": "Inspection en pause",
        "body": "L’équipe a mis en pause l’inspection pour {{request}}."
      },
      "default": {
        "title": "Inspection en pause",
        "body": "{{actor}} a mis en pause l’inspection pour {{request}}. {{note}}"
      },
      "noNote": {
        "title": "Inspection en pause",
        "body": "{{actor}} a mis en pause l’inspection pour {{request}}."
      }
    },
    "asset_request_inspection_reassigned": {
      "toAssigneeNoActor": {
        "title": "Inspection réassignée",
        "body": "L’équipe a réassigné l’inspection pour {{request}} à {{assignee}}."
      },
      "noActor": {
        "title": "Inspection réassignée",
        "body": "L’équipe a réassigné l’inspection pour {{request}}. {{note}}"
      },
      "noActorNoNote": {
        "title": "Inspection réassignée",
        "body": "L’équipe a réassigné l’inspection pour {{request}}."
      },
      "toAssignee": {
        "title": "Inspection réassignée",
        "body": "{{actor}} a réassigné l’inspection pour {{request}} à {{assignee}}."
      },
      "default": {
        "title": "Inspection réassignée",
        "body": "{{actor}} a réassigné l’inspection pour {{request}}. {{note}}"
      },
      "noNote": {
        "title": "Inspection réassignée",
        "body": "{{actor}} a réassigné l’inspection pour {{request}}."
      }
    },
    "asset_request_inspection_resumed": {
      "noActorReopened": {
        "title": "Inspection reprise",
        "body": "L’équipe a repris l’inspection pour {{request}}. Inspection rouverte."
      },
      "reopened": {
        "title": "Inspection reprise",
        "body": "{{actor}} a repris l’inspection pour {{request}}. Inspection rouverte."
      },
      "noActor": {
        "title": "Inspection reprise",
        "body": "L’équipe a repris l’inspection pour {{request}}."
      },
      "default": {
        "title": "Inspection reprise",
        "body": "{{actor}} a repris l’inspection pour {{request}}."
      }
    },
    "asset_request_inspection_started": {
      "noActor": {
        "title": "Inspection commencée",
        "body": "L’équipe a commencé l’inspection pour {{request}}. {{note}}"
      },
      "noActorNoNote": {
        "title": "Inspection commencée",
        "body": "L’équipe a commencé l’inspection pour {{request}}."
      },
      "default": {
        "title": "Inspection commencée",
        "body": "{{actor}} a commencé l’inspection pour {{request}}. {{note}}"
      },
      "noNote": {
        "title": "Inspection commencée",
        "body": "{{actor}} a commencé l’inspection pour {{request}}."
      }
    },
    "asset_request_job_cancelled": {
      "noActor": {
        "title": "Intervention annulée",
        "body": "L’équipe a annulé l’intervention pour {{request}}. {{note}}"
      },
      "noActorNoNote": {
        "title": "Intervention annulée",
        "body": "L’équipe a annulé l’intervention pour {{request}}."
      },
      "default": {
        "title": "Intervention annulée",
        "body": "{{actor}} a annulé l’intervention pour {{request}}. {{note}}"
      },
      "noNote": {
        "title": "Intervention annulée",
        "body": "{{actor}} a annulé l’intervention pour {{request}}."
      }
    },
    "asset_request_job_completed": {
      "noActorNoJobLegacy": {
        "title": "Intervention terminée",
        "body": "L’équipe a terminé l’intervention pour votre demande. Examinez le travail et confirmez le correctif."
      },
      "noActorNoJob": {
        "title": "Intervention terminée",
        "body": "L’équipe a terminé l’intervention pour votre demande. Examinez le travail et confirmez le correctif."
      },
      "noJobLegacy": {
        "title": "Intervention terminée",
        "body": "{{actor}} a terminé l’intervention pour votre demande. Examinez le travail et confirmez le correctif."
      },
      "noJob": {
        "title": "Intervention terminée",
        "body": "{{actor}} a terminé l’intervention pour votre demande. Examinez le travail et confirmez le correctif."
      },
      "noActor": {
        "title": "Intervention terminée",
        "body": "L’équipe a terminé l’intervention « {{job}} ». Examinez le travail et confirmez le correctif."
      },
      "default": {
        "title": "Intervention terminée",
        "body": "{{actor}} a terminé l’intervention « {{job}} ». Examinez le travail et confirmez le correctif."
      }
    },
    "asset_request_job_created": {
      "noActorOutsideRepairsLegacy": {
        "title": "Intervention créée à partir de la demande",
        "body": "L’équipe a créé une intervention pour {{request}} hors des réparations approuvées : « {{job}} »."
      },
      "outsideRepairsLegacy": {
        "title": "Intervention créée à partir de la demande",
        "body": "{{actor}} a créé une intervention pour {{request}} hors des réparations approuvées : « {{job}} »."
      },
      "noActorLegacy": {
        "title": "Intervention créée à partir de la demande",
        "body": "L’équipe a créé une intervention pour {{request}} : « {{job}} »."
      },
      "noActorFromRepairLegacy": {
        "title": "Intervention créée à partir de la demande",
        "body": "L’équipe a créé une intervention pour {{request}} à partir d’une réparation approuvée : « {{job}} »."
      },
      "noActorFollowUpLegacy": {
        "title": "Intervention créée à partir de la demande",
        "body": "L’équipe a proposé une intervention de suivi pour {{request}} : « {{job}} »."
      },
      "defaultLegacy": {
        "title": "Intervention créée à partir de la demande",
        "body": "{{actor}} a créé une intervention pour {{request}} : « {{job}} »."
      },
      "fromRepairLegacy": {
        "title": "Intervention créée à partir de la demande",
        "body": "{{actor}} a créé une intervention pour {{request}} à partir d’une réparation approuvée : « {{job}} »."
      },
      "followUpLegacy": {
        "title": "Intervention créée à partir de la demande",
        "body": "{{actor}} a proposé une intervention de suivi pour {{request}} : « {{job}} »."
      },
      "noActorOutsideRepairs": {
        "title": "Intervention créée à partir de la demande",
        "body": "L’équipe a créé une intervention pour {{request}} hors des réparations approuvées : « {{job}} »."
      },
      "noActorFromRepair": {
        "title": "Intervention créée à partir de la demande",
        "body": "L’équipe a créé une intervention pour {{request}} à partir d’une réparation approuvée : « {{job}} »."
      },
      "noActorFollowUp": {
        "title": "Intervention créée à partir de la demande",
        "body": "L’équipe a proposé une intervention de suivi pour {{request}} : « {{job}} »."
      },
      "noActor": {
        "title": "Intervention créée à partir de la demande",
        "body": "L’équipe a créé une intervention pour {{request}} : « {{job}} »."
      },
      "outsideRepairs": {
        "title": "Intervention créée à partir de la demande",
        "body": "{{actor}} a créé une intervention pour {{request}} hors des réparations approuvées : « {{job}} »."
      },
      "fromRepair": {
        "title": "Intervention créée à partir de la demande",
        "body": "{{actor}} a créé une intervention pour {{request}} à partir d’une réparation approuvée : « {{job}} »."
      },
      "followUp": {
        "title": "Intervention créée à partir de la demande",
        "body": "{{actor}} a proposé une intervention de suivi pour {{request}} : « {{job}} »."
      },
      "default": {
        "title": "Intervention créée à partir de la demande",
        "body": "{{actor}} a créé une intervention pour {{request}} : « {{job}} »."
      }
    },
    "asset_request_job_paused": {
      "noActor": {
        "title": "Intervention en pause",
        "body": "L’équipe a mis en pause l’intervention pour {{request}}. {{note}}"
      },
      "noActorNoNote": {
        "title": "Intervention en pause",
        "body": "L’équipe a mis en pause l’intervention pour {{request}}."
      },
      "default": {
        "title": "Intervention en pause",
        "body": "{{actor}} a mis en pause l’intervention pour {{request}}. {{note}}"
      },
      "noNote": {
        "title": "Intervention en pause",
        "body": "{{actor}} a mis en pause l’intervention pour {{request}}."
      }
    },
    "asset_request_job_resumed": {
      "noActor": {
        "title": "Intervention reprise",
        "body": "L’équipe a repris l’intervention pour {{request}}. {{note}}"
      },
      "noActorNoNote": {
        "title": "Intervention reprise",
        "body": "L’équipe a repris l’intervention pour {{request}}."
      },
      "default": {
        "title": "Intervention reprise",
        "body": "{{actor}} a repris l’intervention pour {{request}}. {{note}}"
      },
      "noNote": {
        "title": "Intervention reprise",
        "body": "{{actor}} a repris l’intervention pour {{request}}."
      }
    },
    "asset_request_job_started": {
      "noActor": {
        "title": "Intervention commencée",
        "body": "L’équipe a commencé l’intervention pour {{request}}. {{note}}"
      },
      "noActorNoNote": {
        "title": "Intervention commencée",
        "body": "L’équipe a commencé l’intervention pour {{request}}."
      },
      "default": {
        "title": "Intervention commencée",
        "body": "{{actor}} a commencé l’intervention pour {{request}}. {{note}}"
      },
      "noNote": {
        "title": "Intervention commencée",
        "body": "{{actor}} a commencé l’intervention pour {{request}}."
      }
    },
    "asset_request_rejected": {
      "withNote": {
        "title": "Votre demande a été refusée",
        "body": "« {{request}} » a été refusée : {{note}}"
      },
      "default": {
        "title": "Votre demande a été refusée",
        "body": "« {{request}} » a été refusée."
      }
    },
    "asset_request_report_shared": {
      "forYouLegacy": {
        "title": "Rapport d’inspection partagé",
        "body": "Le rapport pour {{request}} est prêt pour votre examen : {{findingCount}} constat(s) à traiter."
      },
      "defaultLegacy": {
        "title": "Rapport d’inspection partagé",
        "body": "Le rapport pour {{request}} est prêt à être examiné : {{findingCount}} réparation(s) suggérée(s)."
      },
      "forYouPlainLegacy": {
        "title": "Rapport d’inspection partagé",
        "body": "Le rapport pour {{request}} est prêt pour votre examen."
      },
      "plainLegacy": {
        "title": "Rapport d’inspection partagé",
        "body": "Le rapport pour {{request}} est prêt à être examiné."
      },
      "forYou": {
        "title": "Rapport d’inspection partagé",
        "body": "Le rapport pour {{request}} est prêt pour votre examen : {{findingCount}} constat(s) à traiter."
      },
      "default": {
        "title": "Rapport d’inspection partagé",
        "body": "Le rapport pour {{request}} est prêt à être examiné : {{findingCount}} réparation(s) suggérée(s)."
      },
      "forYouPlain": {
        "title": "Rapport d’inspection partagé",
        "body": "Le rapport pour {{request}} est prêt pour votre examen."
      },
      "plain": {
        "title": "Rapport d’inspection partagé",
        "body": "Le rapport pour {{request}} est prêt à être examiné."
      }
    },
    "asset_request_requested_reschedule": {
      "visitNoInspectionNoPreference": {
        "title": "Autre horaire de visite demandé",
        "body": "Un autre horaire a été demandé pour l’inspection. Aucun horaire souhaité indiqué."
      },
      "visitNoJobNoPreference": {
        "title": "Autre horaire de visite demandé",
        "body": "Un autre horaire a été demandé pour l’intervention. Aucun horaire souhaité indiqué."
      },
      "visitNoInspection": {
        "title": "Autre horaire de visite demandé",
        "body": "Un autre horaire a été demandé pour l’inspection. Préférence : {{preferredDate}} · {{period}} · {{note}}"
      },
      "visitNoInspectionNoNote": {
        "title": "Autre horaire de visite demandé",
        "body": "Un autre horaire a été demandé pour l’inspection. Préférence : {{preferredDate}} · {{period}}"
      },
      "visitNoInspectionNoPeriod": {
        "title": "Autre horaire de visite demandé",
        "body": "Un autre horaire a été demandé pour l’inspection. Préférence : {{preferredDate}} · {{note}}"
      },
      "visitNoPreference": {
        "title": "Autre horaire de visite demandé",
        "body": "Un autre horaire a été demandé pour {{work}}. Aucun horaire souhaité indiqué."
      },
      "visitNoInspectionDateOnly": {
        "title": "Autre horaire de visite demandé",
        "body": "Un autre horaire a été demandé pour l’inspection. Préférence : {{preferredDate}}"
      },
      "visitNoJob": {
        "title": "Autre horaire de visite demandé",
        "body": "Un autre horaire a été demandé pour l’intervention. Préférence : {{preferredDate}} · {{period}} · {{note}}"
      },
      "visitNoJobNoNote": {
        "title": "Autre horaire de visite demandé",
        "body": "Un autre horaire a été demandé pour l’intervention. Préférence : {{preferredDate}} · {{period}}"
      },
      "visitNoJobNoPeriod": {
        "title": "Autre horaire de visite demandé",
        "body": "Un autre horaire a été demandé pour l’intervention. Préférence : {{preferredDate}} · {{note}}"
      },
      "visitNoInspectionNoDate": {
        "title": "Autre horaire de visite demandé",
        "body": "Un autre horaire a été demandé pour l’inspection. {{period}} · {{note}}"
      },
      "visitNoJobDateOnly": {
        "title": "Autre horaire de visite demandé",
        "body": "Un autre horaire a été demandé pour l’intervention. Préférence : {{preferredDate}}"
      },
      "visit": {
        "title": "Autre horaire de visite demandé",
        "body": "Un autre horaire a été demandé pour {{work}}. Préférence : {{preferredDate}} · {{period}} · {{note}}"
      },
      "visitNoInspectionPeriodOnly": {
        "title": "Autre horaire de visite demandé",
        "body": "Un autre horaire a été demandé pour l’inspection. {{period}}"
      },
      "visitNoInspectionNoteOnly": {
        "title": "Autre horaire de visite demandé",
        "body": "Un autre horaire a été demandé pour l’inspection. {{note}}"
      },
      "visitNoNote": {
        "title": "Autre horaire de visite demandé",
        "body": "Un autre horaire a été demandé pour {{work}}. Préférence : {{preferredDate}} · {{period}}"
      },
      "visitNoPeriod": {
        "title": "Autre horaire de visite demandé",
        "body": "Un autre horaire a été demandé pour {{work}}. Préférence : {{preferredDate}} · {{note}}"
      },
      "visitNoJobNoDate": {
        "title": "Autre horaire de visite demandé",
        "body": "Un autre horaire a été demandé pour l’intervention. {{period}} · {{note}}"
      },
      "requestNoRequest": {
        "title": "Nouvel horaire demandé",
        "body": "Demande — le demandeur souhaite un autre horaire. ({{preferredDate}}, {{periodLabel}})"
      },
      "requestNoRequestNoPeriod": {
        "title": "Nouvel horaire demandé",
        "body": "Demande — le demandeur souhaite un autre horaire. ({{preferredDate}})"
      },
      "visitDateOnly": {
        "title": "Autre horaire de visite demandé",
        "body": "Un autre horaire a été demandé pour {{work}}. Préférence : {{preferredDate}}"
      },
      "visitNoJobPeriodOnly": {
        "title": "Autre horaire de visite demandé",
        "body": "Un autre horaire a été demandé pour l’intervention. {{period}}"
      },
      "visitNoJobNoteOnly": {
        "title": "Autre horaire de visite demandé",
        "body": "Un autre horaire a été demandé pour l’intervention. {{note}}"
      },
      "requestNoRequestNoPreference": {
        "title": "Nouvel horaire demandé",
        "body": "Demande — le demandeur souhaite un autre horaire."
      },
      "visitNoDate": {
        "title": "Autre horaire de visite demandé",
        "body": "Un autre horaire a été demandé pour {{work}}. {{period}} · {{note}}"
      },
      "request": {
        "title": "Nouvel horaire demandé",
        "body": "{{request}} — le demandeur souhaite un autre horaire. ({{preferredDate}}, {{periodLabel}})"
      },
      "requestNoPeriod": {
        "title": "Nouvel horaire demandé",
        "body": "{{request}} — le demandeur souhaite un autre horaire. ({{preferredDate}})"
      },
      "visitPeriodOnly": {
        "title": "Autre horaire de visite demandé",
        "body": "Un autre horaire a été demandé pour {{work}}. {{period}}"
      },
      "visitNoteOnly": {
        "title": "Autre horaire de visite demandé",
        "body": "Un autre horaire a été demandé pour {{work}}. {{note}}"
      },
      "requestNoPreference": {
        "title": "Nouvel horaire demandé",
        "body": "{{request}} — le demandeur souhaite un autre horaire."
      }
    },
    "asset_request_requester_cancelled": {
      "noRequest": {
        "title": "Demande retirée",
        "body": "Le demandeur a retiré la demande. {{reason}}"
      },
      "noRequestNoReason": {
        "title": "Demande retirée",
        "body": "Le demandeur a retiré la demande."
      },
      "default": {
        "title": "Demande retirée",
        "body": "Le demandeur a retiré {{request}}. {{reason}}"
      },
      "noReason": {
        "title": "Demande retirée",
        "body": "Le demandeur a retiré {{request}}."
      }
    },
    "asset_request_response_received": {
      "approvedLegacy": {
        "title": "Réponse au rapport reçue",
        "body": "Le rapport pour {{request}} a été approuvé."
      },
      "rejectedLegacy": {
        "title": "Réponse au rapport reçue",
        "body": "Le rapport pour {{request}} a été refusé."
      },
      "defaultLegacy": {
        "title": "Réponse au rapport reçue",
        "body": "Le rapport pour {{request}} a été refusé. {{reason}}"
      },
      "approved": {
        "title": "Réponse au rapport reçue",
        "body": "Le rapport pour {{request}} a été approuvé."
      },
      "rejected": {
        "title": "Réponse au rapport reçue",
        "body": "Le rapport pour {{request}} a été refusé."
      },
      "default": {
        "title": "Réponse au rapport reçue",
        "body": "Le rapport pour {{request}} a été refusé. {{reason}}"
      }
    },
    "asset_request_rework_requested": {
      "requesterNoRequesterNoRequestNoReasonLegacy": {
        "title": "Reprise demandée",
        "body": "Le demandeur a demandé une reprise sur la demande."
      },
      "requesterNoRequesterNoReasonLegacy": {
        "title": "Reprise demandée",
        "body": "Le demandeur a demandé une reprise sur « {{request}} »."
      },
      "requesterNoRequestNoReasonLegacy": {
        "title": "Reprise demandée",
        "body": "{{requester}} a demandé une reprise sur la demande."
      },
      "requesterNoReasonLegacy": {
        "title": "Reprise demandée",
        "body": "{{requester}} a demandé une reprise sur « {{request}} »."
      },
      "requesterNoRequesterNoRequestLegacy": {
        "title": "Reprise demandée",
        "body": "Le demandeur a demandé une reprise sur la demande : {{reason}}"
      },
      "requesterNoRequestLegacy": {
        "title": "Reprise demandée",
        "body": "{{requester}} a demandé une reprise sur la demande : {{reason}}"
      },
      "requesterNoRequesterNoRequestNoReason": {
        "title": "Reprise demandée",
        "body": "Le demandeur a demandé une reprise sur la demande."
      },
      "requesterNoRequesterNoReason": {
        "title": "Reprise demandée",
        "body": "Le demandeur a demandé une reprise sur « {{request}} »."
      },
      "requesterNoRequestNoReason": {
        "title": "Reprise demandée",
        "body": "{{requester}} a demandé une reprise sur la demande."
      },
      "requesterNoReason": {
        "title": "Reprise demandée",
        "body": "{{requester}} a demandé une reprise sur « {{request}} »."
      },
      "requesterNoRequesterNoRequest": {
        "title": "Reprise demandée",
        "body": "Le demandeur a demandé une reprise sur la demande : {{reason}}"
      },
      "requesterNoRequester": {
        "title": "Reprise demandée",
        "body": "Le demandeur a demandé une reprise sur « {{request}} » : {{reason}}"
      },
      "requesterNoRequest": {
        "title": "Reprise demandée",
        "body": "{{requester}} a demandé une reprise sur la demande : {{reason}}"
      },
      "teamNoActor": {
        "title": "Reprise demandée",
        "body": "L’équipe a demandé une reprise sur {{request}}. {{note}}"
      },
      "teamNoActorNoNote": {
        "title": "Reprise demandée",
        "body": "L’équipe a demandé une reprise sur {{request}}."
      },
      "requester": {
        "title": "Reprise demandée",
        "body": "{{requester}} a demandé une reprise sur « {{request}} » : {{reason}}"
      },
      "team": {
        "title": "Reprise demandée",
        "body": "{{actor}} a demandé une reprise sur {{request}}. {{note}}"
      },
      "teamNoNote": {
        "title": "Reprise demandée",
        "body": "{{actor}} a demandé une reprise sur {{request}}."
      }
    },
    "asset_request_scheduled": {
      "scheduled": {
        "title": "Votre demande a été planifiée",
        "body": "{{request}} est planifiée le {{scheduledDate}}."
      },
      "rescheduled": {
        "title": "Votre visite a été reprogrammée",
        "body": "{{request}} — nouvelle date : {{newWhen}}."
      }
    },
    "asset_retired": {
      "noAsset": {
        "title": "Actif retiré définitivement",
        "body": "Un actif a été retiré définitivement ({{reason}}). Il ne peut plus recevoir de nouvelles inspections ni interventions. {{note}}"
      },
      "noAssetNoNote": {
        "title": "Actif retiré définitivement",
        "body": "Un actif a été retiré définitivement ({{reason}}). Il ne peut plus recevoir de nouvelles inspections ni interventions."
      },
      "noAssetNoReason": {
        "title": "Actif retiré définitivement",
        "body": "Un actif a été retiré définitivement. Il ne peut plus recevoir de nouvelles inspections ni interventions. {{note}}"
      },
      "noAssetNoReasonNoNote": {
        "title": "Actif retiré définitivement",
        "body": "Un actif a été retiré définitivement. Il ne peut plus recevoir de nouvelles inspections ni interventions."
      },
      "default": {
        "title": "Actif retiré définitivement",
        "body": "{{asset}} a été retiré définitivement ({{reason}}). Il ne peut plus recevoir de nouvelles inspections ni interventions. {{note}}"
      },
      "noNote": {
        "title": "Actif retiré définitivement",
        "body": "{{asset}} a été retiré définitivement ({{reason}}). Il ne peut plus recevoir de nouvelles inspections ni interventions."
      },
      "noReason": {
        "title": "Actif retiré définitivement",
        "body": "{{asset}} a été retiré définitivement. Il ne peut plus recevoir de nouvelles inspections ni interventions. {{note}}"
      },
      "noReasonNoNote": {
        "title": "Actif retiré définitivement",
        "body": "{{asset}} a été retiré définitivement. Il ne peut plus recevoir de nouvelles inspections ni interventions."
      }
    },
    "asset_share_accepted": {
      "noContactNoAsset": {
        "title": "Partage d’actif accepté",
        "body": "Un contact a accepté l’accès à l’actif."
      },
      "noAsset": {
        "title": "Partage d’actif accepté",
        "body": "{{contact}} a accepté l’accès à l’actif."
      },
      "noContact": {
        "title": "Partage d’actif accepté",
        "body": "Un contact a accepté l’accès à {{asset}}."
      },
      "default": {
        "title": "Partage d’actif accepté",
        "body": "{{contact}} a accepté l’accès à {{asset}}."
      }
    },
    "asset_share_declined": {
      "noContactNoAsset": {
        "title": "Partage d’actif refusé",
        "body": "Un contact a refusé l’accès à l’actif."
      },
      "noAsset": {
        "title": "Partage d’actif refusé",
        "body": "{{contact}} a refusé l’accès à l’actif."
      },
      "noContact": {
        "title": "Partage d’actif refusé",
        "body": "Un contact a refusé l’accès à {{asset}}."
      },
      "default": {
        "title": "Partage d’actif refusé",
        "body": "{{contact}} a refusé l’accès à {{asset}}."
      }
    },
    "asset_share_ended": {
      "noAsset": {
        "title": "Actif partagé retiré définitivement",
        "body": "Un actif a été retiré définitivement par son propriétaire ; votre accès a donc pris fin. Tout ce que vous avez signalé dessus reste dans son dossier."
      },
      "default": {
        "title": "Actif partagé retiré définitivement",
        "body": "{{asset}} a été retiré définitivement par son propriétaire ; votre accès a donc pris fin. Tout ce que vous avez signalé dessus reste dans son dossier."
      }
    },
    "asset_team_assigned": {
      "noTeam": {
        "title": "Nouvel actif dans votre équipe",
        "body": "{{asset}} a été assigné à votre équipe."
      },
      "default": {
        "title": "Nouvel actif dans votre équipe",
        "body": "{{asset}} a été assigné à {{team}}."
      }
    },
    "asset_team_removed": {
      "default": {
        "title": "Actif déplacé hors de votre équipe",
        "body": "{{asset}} n’est plus assigné à votre équipe."
      }
    },
    "automation_notice": {
      "default": {
        "title": "{{title}}",
        "body": "{{body}}"
      }
    },
    "completion_submitted": {
      "requesterFirstNoActorNoJobNoRequesterLegacy": {
        "title": "Intervention terminée — le demandeur confirme d’abord",
        "body": "Un collègue a terminé une intervention. Le demandeur confirme d’abord le correctif ; vous vérifiez ensuite."
      },
      "requesterFirstNoActorNoJobNoRequester": {
        "title": "Intervention terminée — le demandeur confirme d’abord",
        "body": "Un collègue a terminé une intervention. Le demandeur confirme d’abord le correctif ; vous vérifiez ensuite."
      },
      "requesterFirstNoActorNoRequester": {
        "title": "Intervention terminée — le demandeur confirme d’abord",
        "body": "Un collègue a terminé « {{job}} ». Le demandeur confirme d’abord le correctif ; vous vérifiez ensuite."
      },
      "requesterFirstNoJobNoRequesterLegacy": {
        "title": "Intervention terminée — le demandeur confirme d’abord",
        "body": "{{actor}} a terminé une intervention. Le demandeur confirme d’abord le correctif ; vous vérifiez ensuite."
      },
      "requesterFirstNoJobNoRequester": {
        "title": "Intervention terminée — le demandeur confirme d’abord",
        "body": "{{actor}} a terminé une intervention. Le demandeur confirme d’abord le correctif ; vous vérifiez ensuite."
      },
      "requesterFirstNoActorNoJobLegacy": {
        "title": "Intervention terminée — le demandeur confirme d’abord",
        "body": "Un collègue a terminé une intervention. {{requester}} confirme d’abord le correctif ; vous vérifiez ensuite."
      },
      "requesterFirstNoActorNoJob": {
        "title": "Intervention terminée — le demandeur confirme d’abord",
        "body": "Un collègue a terminé une intervention. {{requester}} confirme d’abord le correctif ; vous vérifiez ensuite."
      },
      "requesterFirstNoRequester": {
        "title": "Intervention terminée — le demandeur confirme d’abord",
        "body": "{{actor}} a terminé « {{job}} ». Le demandeur confirme d’abord le correctif ; vous vérifiez ensuite."
      },
      "requesterFirstNoActor": {
        "title": "Intervention terminée — le demandeur confirme d’abord",
        "body": "Un collègue a terminé « {{job}} ». {{requester}} confirme d’abord le correctif ; vous vérifiez ensuite."
      },
      "requesterFirstNoJobLegacy": {
        "title": "Intervention terminée — le demandeur confirme d’abord",
        "body": "{{actor}} a terminé une intervention. {{requester}} confirme d’abord le correctif ; vous vérifiez ensuite."
      },
      "requesterFirstNoJob": {
        "title": "Intervention terminée — le demandeur confirme d’abord",
        "body": "{{actor}} a terminé une intervention. {{requester}} confirme d’abord le correctif ; vous vérifiez ensuite."
      },
      "requesterFirst": {
        "title": "Intervention terminée — le demandeur confirme d’abord",
        "body": "{{actor}} a terminé « {{job}} ». {{requester}} confirme d’abord le correctif ; vous vérifiez ensuite."
      },
      "forApprovalSelf": {
        "title": "Votre clôture est prête à être vérifiée",
        "body": "Vous avez terminé « {{job}} ». Vérifiez-la pour clôturer le travail."
      },
      "forApprovalSelfNoJob": {
        "title": "Votre clôture est prête à être vérifiée",
        "body": "Vous avez terminé un travail. Vérifiez-le pour le clôturer."
      },
      "forApprovalNoActorNoJobLegacy": {
        "title": "Achèvement d’intervention soumis pour approbation",
        "body": "Un collègue a terminé une intervention. Examinez-la et approuvez-la."
      },
      "forApprovalNoActorNoJob": {
        "title": "Achèvement d’intervention soumis pour approbation",
        "body": "Un collègue a terminé une intervention. Examinez-la et approuvez-la."
      },
      "forApprovalNoActor": {
        "title": "Achèvement d’intervention soumis pour approbation",
        "body": "Un collègue a terminé « {{job}} ». Examinez-la et approuvez-la."
      },
      "forApprovalNoJobLegacy": {
        "title": "Achèvement d’intervention soumis pour approbation",
        "body": "{{actor}} a terminé une intervention. Examinez-la et approuvez-la."
      },
      "forApprovalNoJob": {
        "title": "Achèvement d’intervention soumis pour approbation",
        "body": "{{actor}} a terminé une intervention. Examinez-la et approuvez-la."
      },
      "forApproval": {
        "title": "Achèvement d’intervention soumis pour approbation",
        "body": "{{actor}} a terminé « {{job}} ». Examinez-la et approuvez-la."
      }
    },
    "document_expiring": {
      "certificateNoDocument": {
        "title": "Certificat qui expire bientôt",
        "body": "Un document · {{asset}} expire le {{expiryDate}}."
      },
      "certificateNoDocumentNoAsset": {
        "title": "Certificat qui expire bientôt",
        "body": "Un document expire le {{expiryDate}}."
      },
      "documentNoDocument": {
        "title": "Document qui expire bientôt",
        "body": "Un document · {{asset}} expire le {{expiryDate}}."
      },
      "documentNoDocumentNoAsset": {
        "title": "Document qui expire bientôt",
        "body": "Un document expire le {{expiryDate}}."
      },
      "certificate": {
        "title": "Certificat qui expire bientôt",
        "body": "{{document}} · {{asset}} expire le {{expiryDate}}."
      },
      "certificateNoAsset": {
        "title": "Certificat qui expire bientôt",
        "body": "{{document}} expire le {{expiryDate}}."
      },
      "document": {
        "title": "Document qui expire bientôt",
        "body": "{{document}} · {{asset}} expire le {{expiryDate}}."
      },
      "documentNoAsset": {
        "title": "Document qui expire bientôt",
        "body": "{{document}} expire le {{expiryDate}}."
      }
    },
    "document_rejected": {
      "noValidatorNoAsset": {
        "title": "Document rejeté",
        "body": "Le validateur a rejeté « {{document}} » pour un actif. Motif : {{reason}}"
      },
      "noValidator": {
        "title": "Document rejeté",
        "body": "Le validateur a rejeté « {{document}} » pour {{asset}}. Motif : {{reason}}"
      },
      "noValidatorNoAssetNoReason": {
        "title": "Document rejeté",
        "body": "Le validateur a rejeté « {{document}} » pour un actif."
      },
      "noAsset": {
        "title": "Document rejeté",
        "body": "{{validator}} a rejeté « {{document}} » pour un actif. Motif : {{reason}}"
      },
      "noValidatorNoReason": {
        "title": "Document rejeté",
        "body": "Le validateur a rejeté « {{document}} » pour {{asset}}."
      },
      "default": {
        "title": "Document rejeté",
        "body": "{{validator}} a rejeté « {{document}} » pour {{asset}}. Motif : {{reason}}"
      },
      "noAssetNoReason": {
        "title": "Document rejeté",
        "body": "{{validator}} a rejeté « {{document}} » pour un actif."
      },
      "noReason": {
        "title": "Document rejeté",
        "body": "{{validator}} a rejeté « {{document}} » pour {{asset}}."
      }
    },
    "document_validated": {
      "noValidatorNoAsset": {
        "title": "Document validé",
        "body": "Le validateur a validé « {{document}} » pour un actif."
      },
      "noValidator": {
        "title": "Document validé",
        "body": "Le validateur a validé « {{document}} » pour {{asset}}."
      },
      "noAsset": {
        "title": "Document validé",
        "body": "{{validator}} a validé « {{document}} » pour un actif."
      },
      "default": {
        "title": "Document validé",
        "body": "{{validator}} a validé « {{document}} » pour {{asset}}."
      }
    },
    "document_validation_requested": {
      "reminderNoRequesterNoAsset": {
        "title": "Rappel : valider « {{document}} »",
        "body": "Un collègue vous a rappelé de valider {{documentType}} pour un actif (expire le {{expiryDate}})."
      },
      "reminderNoRequester": {
        "title": "Rappel : valider « {{document}} »",
        "body": "Un collègue vous a rappelé de valider {{documentType}} pour {{asset}} (expire le {{expiryDate}})."
      },
      "reminderNoAsset": {
        "title": "Rappel : valider « {{document}} »",
        "body": "{{requester}} vous a rappelé de valider {{documentType}} pour un actif (expire le {{expiryDate}})."
      },
      "reminderNoRequesterNoAssetNoExpiry": {
        "title": "Rappel : valider « {{document}} »",
        "body": "Un collègue vous a rappelé de valider {{documentType}} pour un actif."
      },
      "requestNoRequesterNoAsset": {
        "title": "Valider « {{document}} »",
        "body": "Un collègue vous a demandé de valider {{documentType}} pour un actif (expire le {{expiryDate}})."
      },
      "reminder": {
        "title": "Rappel : valider « {{document}} »",
        "body": "{{requester}} vous a rappelé de valider {{documentType}} pour {{asset}} (expire le {{expiryDate}})."
      },
      "reminderNoRequesterNoExpiry": {
        "title": "Rappel : valider « {{document}} »",
        "body": "Un collègue vous a rappelé de valider {{documentType}} pour {{asset}}."
      },
      "requestNoRequester": {
        "title": "Valider « {{document}} »",
        "body": "Un collègue vous a demandé de valider {{documentType}} pour {{asset}} (expire le {{expiryDate}})."
      },
      "reminderNoAssetNoExpiry": {
        "title": "Rappel : valider « {{document}} »",
        "body": "{{requester}} vous a rappelé de valider {{documentType}} pour un actif."
      },
      "requestNoAsset": {
        "title": "Valider « {{document}} »",
        "body": "{{requester}} vous a demandé de valider {{documentType}} pour un actif (expire le {{expiryDate}})."
      },
      "requestNoRequesterNoAssetNoExpiry": {
        "title": "Valider « {{document}} »",
        "body": "Un collègue vous a demandé de valider {{documentType}} pour un actif."
      },
      "reminderNoExpiry": {
        "title": "Rappel : valider « {{document}} »",
        "body": "{{requester}} vous a rappelé de valider {{documentType}} pour {{asset}}."
      },
      "request": {
        "title": "Valider « {{document}} »",
        "body": "{{requester}} vous a demandé de valider {{documentType}} pour {{asset}} (expire le {{expiryDate}})."
      },
      "requestNoRequesterNoExpiry": {
        "title": "Valider « {{document}} »",
        "body": "Un collègue vous a demandé de valider {{documentType}} pour {{asset}}."
      },
      "requestNoAssetNoExpiry": {
        "title": "Valider « {{document}} »",
        "body": "{{requester}} vous a demandé de valider {{documentType}} pour un actif."
      },
      "requestNoExpiry": {
        "title": "Valider « {{document}} »",
        "body": "{{requester}} vous a demandé de valider {{documentType}} pour {{asset}}."
      },
      "uploadedByYou": {
        "title": "Valider « {{document}} »",
        "body": "Vous avez ajouté {{documentType}} pour {{asset}} (expire le {{expiryDate}})."
      },
      "uploadedByColleague": {
        "title": "Valider « {{document}} »",
        "body": "Un collègue a ajouté {{documentType}} pour {{asset}} (expire le {{expiryDate}})."
      },
      "uploaded": {
        "title": "Valider « {{document}} »",
        "body": "{{uploader}} a ajouté {{documentType}} pour {{asset}} (expire le {{expiryDate}})."
      },
      "uploadedByYouNoExpiry": {
        "title": "Valider « {{document}} »",
        "body": "Vous avez ajouté {{documentType}} pour {{asset}}."
      },
      "uploadedByColleagueNoExpiry": {
        "title": "Valider « {{document}} »",
        "body": "Un collègue a ajouté {{documentType}} pour {{asset}}."
      },
      "uploadedNoExpiry": {
        "title": "Valider « {{document}} »",
        "body": "{{uploader}} a ajouté {{documentType}} pour {{asset}}."
      }
    },
    "draft_created": {
      "noAssetLegacy": {
        "title": "Brouillon d’inspection créé",
        "body": "L’inspection planifiée pour un actif - {{template}} est prête à être réalisée."
      },
      "noAsset": {
        "title": "Brouillon d’inspection créé",
        "body": "L’inspection planifiée pour un actif - {{template}} est prête à être réalisée."
      },
      "default": {
        "title": "Brouillon d’inspection créé",
        "body": "L’inspection planifiée pour {{asset}} - {{template}} est prête à être réalisée."
      }
    },
    "evidence_requested": {
      "noActorNoJobLegacy": {
        "title": "Justificatifs supplémentaires demandés pour votre intervention",
        "body": "Le vérificateur a demandé des justificatifs supplémentaires pour une intervention. {{reason}}"
      },
      "noActorNoJob": {
        "title": "Justificatifs supplémentaires demandés pour votre intervention",
        "body": "Le vérificateur a demandé des justificatifs supplémentaires pour une intervention. {{reason}}"
      },
      "noActorNoJobNoReasonLegacy": {
        "title": "Justificatifs supplémentaires demandés pour votre intervention",
        "body": "Le vérificateur a demandé des justificatifs supplémentaires pour une intervention."
      },
      "noActorNoJobNoReason": {
        "title": "Justificatifs supplémentaires demandés pour votre intervention",
        "body": "Le vérificateur a demandé des justificatifs supplémentaires pour une intervention."
      },
      "noActor": {
        "title": "Justificatifs supplémentaires demandés pour votre intervention",
        "body": "Le vérificateur a demandé des justificatifs supplémentaires pour « {{job}} ». {{reason}}"
      },
      "noActorNoReason": {
        "title": "Justificatifs supplémentaires demandés pour votre intervention",
        "body": "Le vérificateur a demandé des justificatifs supplémentaires pour « {{job}} »."
      },
      "noJobLegacy": {
        "title": "Justificatifs supplémentaires demandés pour votre intervention",
        "body": "{{actor}} a demandé des justificatifs supplémentaires pour une intervention. {{reason}}"
      },
      "noJob": {
        "title": "Justificatifs supplémentaires demandés pour votre intervention",
        "body": "{{actor}} a demandé des justificatifs supplémentaires pour une intervention. {{reason}}"
      },
      "noJobNoReasonLegacy": {
        "title": "Justificatifs supplémentaires demandés pour votre intervention",
        "body": "{{actor}} a demandé des justificatifs supplémentaires pour une intervention."
      },
      "noJobNoReason": {
        "title": "Justificatifs supplémentaires demandés pour votre intervention",
        "body": "{{actor}} a demandé des justificatifs supplémentaires pour une intervention."
      },
      "default": {
        "title": "Justificatifs supplémentaires demandés pour votre intervention",
        "body": "{{actor}} a demandé des justificatifs supplémentaires pour « {{job}} ». {{reason}}"
      },
      "noReason": {
        "title": "Justificatifs supplémentaires demandés pour votre intervention",
        "body": "{{actor}} a demandé des justificatifs supplémentaires pour « {{job}} »."
      }
    },
    "free_period_ending": {
      "ended": {
        "title": "Votre période gratuite est terminée",
        "body": "Votre espace de travail est désormais en lecture seule. Choisissez un forfait pour continuer à travailler. Rien n’a été supprimé."
      },
      "tomorrow": {
        "title": "Votre période gratuite se termine demain",
        "body": "Choisissez un forfait avant le {{endDate}} pour continuer à ajouter et modifier. Rien n’est supprimé, quoi que vous décidiez."
      },
      "inDays": {
        "title": "Votre période gratuite se termine dans {{daysLeft}} jours",
        "body": "Choisissez un forfait avant le {{endDate}} pour continuer à ajouter et modifier. Rien n’est supprimé, quoi que vous décidiez."
      }
    },
    "inspection_approved": {
      "noActorNoAsset": {
        "title": "Votre inspection a été approuvée",
        "body": "L’approbateur a approuvé votre inspection sur un actif."
      },
      "noActor": {
        "title": "Votre inspection a été approuvée",
        "body": "L’approbateur a approuvé votre inspection sur {{asset}}."
      },
      "noAsset": {
        "title": "Votre inspection a été approuvée",
        "body": "{{actor}} a approuvé votre inspection sur un actif."
      },
      "default": {
        "title": "Votre inspection a été approuvée",
        "body": "{{actor}} a approuvé votre inspection sur {{asset}}."
      }
    },
    "inspection_assigned": {
      "scheduledByActorNoTemplateNoAsset": {
        "title": "Une inspection vous a été assignée",
        "body": "{{actor}} vous a assigné une inspection sur un actif · {{when}}."
      },
      "byActorNoTemplateNoAsset": {
        "title": "Une inspection vous a été assignée",
        "body": "{{actor}} vous a assigné une inspection sur un actif."
      },
      "scheduledByActorNoTemplate": {
        "title": "Une inspection vous a été assignée",
        "body": "{{actor}} vous a assigné une inspection sur {{asset}} · {{when}}."
      },
      "byActorNoTemplate": {
        "title": "Une inspection vous a été assignée",
        "body": "{{actor}} vous a assigné une inspection sur {{asset}}."
      },
      "scheduledByActorNoAsset": {
        "title": "Une inspection vous a été assignée",
        "body": "{{actor}} vous a assigné « {{template}} » sur un actif · {{when}}."
      },
      "byActorNoAsset": {
        "title": "Une inspection vous a été assignée",
        "body": "{{actor}} vous a assigné « {{template}} » sur un actif."
      },
      "scheduledNoTemplateNoAsset": {
        "title": "Une inspection vous a été assignée",
        "body": "Une inspection · Un actif · {{when}}."
      },
      "scheduledByActor": {
        "title": "Une inspection vous a été assignée",
        "body": "{{actor}} vous a assigné « {{template}} » sur {{asset}} · {{when}}."
      },
      "noTemplateNoAsset": {
        "title": "Une inspection vous a été assignée",
        "body": "Une inspection · Un actif."
      },
      "byActor": {
        "title": "Une inspection vous a été assignée",
        "body": "{{actor}} vous a assigné « {{template}} » sur {{asset}}."
      },
      "scheduledNoTemplate": {
        "title": "Une inspection vous a été assignée",
        "body": "Une inspection · {{asset}} · {{when}}."
      },
      "scheduledNoAsset": {
        "title": "Une inspection vous a été assignée",
        "body": "{{template}} · Un actif · {{when}}."
      },
      "noTemplate": {
        "title": "Une inspection vous a été assignée",
        "body": "Une inspection · {{asset}}."
      },
      "noAsset": {
        "title": "Une inspection vous a été assignée",
        "body": "{{template}} · Un actif."
      },
      "scheduled": {
        "title": "Une inspection vous a été assignée",
        "body": "{{template}} · {{asset}} · {{when}}."
      },
      "default": {
        "title": "Une inspection vous a été assignée",
        "body": "{{template}} · {{asset}}."
      }
    },
    "inspection_completed_for_approval": {
      "noActorNoAsset": {
        "title": "Inspection prête pour votre approbation",
        "body": "Un collègue a terminé une inspection sur un actif. Examinez-la et approuvez-la."
      },
      "noActor": {
        "title": "Inspection prête pour votre approbation",
        "body": "Un collègue a terminé une inspection sur {{asset}}. Examinez-la et approuvez-la."
      },
      "noAsset": {
        "title": "Inspection prête pour votre approbation",
        "body": "{{actor}} a terminé une inspection sur un actif. Examinez-la et approuvez-la."
      },
      "default": {
        "title": "Inspection prête pour votre approbation",
        "body": "{{actor}} a terminé une inspection sur {{asset}}. Examinez-la et approuvez-la."
      }
    },
    "inspection_reassigned": {
      "inspectionNoAsset": {
        "title": "Inspection réassignée",
        "body": "L’inspection de cet actif ne vous est plus assignée."
      },
      "inspection": {
        "title": "Inspection réassignée",
        "body": "L’inspection pour {{asset}} ne vous est plus assignée."
      },
      "scheduleNoAsset": {
        "title": "Inspection réassignée",
        "body": "Cette inspection ne vous est plus assignée."
      },
      "schedule": {
        "title": "Inspection réassignée",
        "body": "{{asset}} ne vous est plus assigné."
      }
    },
    "inspection_reopened": {
      "noActorNoAsset": {
        "title": "Votre inspection a été rouverte",
        "body": "Un collègue a rouvert votre inspection sur un actif."
      },
      "noActor": {
        "title": "Votre inspection a été rouverte",
        "body": "Un collègue a rouvert votre inspection sur {{asset}}."
      },
      "noAsset": {
        "title": "Votre inspection a été rouverte",
        "body": "{{actor}} a rouvert votre inspection sur un actif."
      },
      "default": {
        "title": "Votre inspection a été rouverte",
        "body": "{{actor}} a rouvert votre inspection sur {{asset}}."
      }
    },
    "inspection_report_shared": {
      "recipientNoSharerNoAsset": {
        "title": "Rapport d’inspection prêt",
        "body": "L’inspecteur a partagé le rapport d’inspection pour un actif. Examinez-le et validez-le."
      },
      "recipientNoSharer": {
        "title": "Rapport d’inspection prêt",
        "body": "L’inspecteur a partagé le rapport d’inspection pour {{asset}}. Examinez-le et validez-le."
      },
      "recipientNoAsset": {
        "title": "Rapport d’inspection prêt",
        "body": "{{sharer}} a partagé le rapport d’inspection pour un actif. Examinez-le et validez-le."
      },
      "recipient": {
        "title": "Rapport d’inspection prêt",
        "body": "{{sharer}} a partagé le rapport d’inspection pour {{asset}}. Examinez-le et validez-le."
      },
      "sharerNoRecipient": {
        "title": "Rapport d’inspection partagé",
        "body": "Lien de relecture prêt pour le destinataire."
      },
      "resentNoRecipient": {
        "title": "Rapport d’inspection renvoyé",
        "body": "Envoyé de nouveau au destinataire."
      },
      "sharer": {
        "title": "Rapport d’inspection partagé",
        "body": "Lien de relecture prêt pour {{recipient}}."
      },
      "sharerBlankName": {
        "title": "Rapport d’inspection partagé",
        "body": "Le lien de relecture est prêt."
      },
      "resentBlankName": {
        "title": "Rapport d’inspection renvoyé",
        "body": "Lien du rapport mis à jour."
      },
      "resent": {
        "title": "Rapport d’inspection renvoyé",
        "body": "Envoyé de nouveau à {{recipient}}."
      }
    },
    "inspection_sent_back": {
      "noActorNoAsset": {
        "title": "Votre inspection a été renvoyée",
        "body": "Votre approbateur a renvoyé votre inspection sur un actif : {{reason}}"
      },
      "noActor": {
        "title": "Votre inspection a été renvoyée",
        "body": "Votre approbateur a renvoyé votre inspection sur {{asset}} : {{reason}}"
      },
      "noAsset": {
        "title": "Votre inspection a été renvoyée",
        "body": "{{actor}} a renvoyé votre inspection sur un actif : {{reason}}"
      },
      "default": {
        "title": "Votre inspection a été renvoyée",
        "body": "{{actor}} a renvoyé votre inspection sur {{asset}} : {{reason}}"
      }
    },
    "inspection_unassigned": {
      "inspectionNoAsset": {
        "title": "Inspection désassignée",
        "body": "L’inspection de cet actif ne vous est plus assignée."
      },
      "inspection": {
        "title": "Inspection désassignée",
        "body": "L’inspection pour {{asset}} ne vous est plus assignée."
      },
      "scheduleNoAsset": {
        "title": "Inspection désassignée",
        "body": "Cette inspection ne vous est plus assignée."
      },
      "schedule": {
        "title": "Inspection désassignée",
        "body": "{{asset}} ne vous est plus assigné."
      }
    },
    "inspection_visit_proposed": {
      "noInspection": {
        "title": "Confirmez l’horaire de la visite",
        "body": "Une inspection est prévue le {{when}} — confirmez que quelqu’un peut être présent, ou demandez un autre horaire."
      },
      "default": {
        "title": "Confirmez l’horaire de la visite",
        "body": "{{inspection}} est prévue le {{when}} — confirmez que quelqu’un peut être présent, ou demandez un autre horaire."
      }
    },
    "job_accepted": {
      "noActorNoJobLegacy": {
        "title": "Intervention acceptée",
        "body": "L’assigné a accepté une intervention."
      },
      "noActorNoJob": {
        "title": "Intervention acceptée",
        "body": "L’assigné a accepté une intervention."
      },
      "noActor": {
        "title": "Intervention acceptée",
        "body": "L’assigné a accepté « {{job}} »."
      },
      "noJobLegacy": {
        "title": "Intervention acceptée",
        "body": "{{actor}} a accepté une intervention."
      },
      "noJob": {
        "title": "Intervention acceptée",
        "body": "{{actor}} a accepté une intervention."
      },
      "default": {
        "title": "Intervention acceptée",
        "body": "{{actor}} a accepté « {{job}} »."
      }
    },
    "job_approver_assigned": {
      "noJob": {
        "title": "Responsabilité d’approbation attribuée",
        "body": "Une intervention nécessitera votre examen."
      },
      "default": {
        "title": "Responsabilité d’approbation attribuée",
        "body": "{{job}} nécessitera votre examen."
      }
    },
    "job_approver_removed": {
      "noJobLegacy": {
        "title": "Responsabilité d’approbation modifiée",
        "body": "Vous n’êtes plus l’approbateur d’une intervention."
      },
      "noJob": {
        "title": "Responsabilité d’approbation modifiée",
        "body": "Vous n’êtes plus l’approbateur d’une intervention."
      },
      "default": {
        "title": "Responsabilité d’approbation modifiée",
        "body": "Vous n’êtes plus l’approbateur pour {{job}}."
      }
    },
    "job_assigned": {
      "byActorNoJobLegacy": {
        "title": "Une intervention vous a été assignée",
        "body": "{{actor}} vous a assigné une intervention · {{asset}} · échéance le {{dueDate}}."
      },
      "byActorNoJob": {
        "title": "Une intervention vous a été assignée",
        "body": "{{actor}} vous a assigné une intervention · {{asset}} · échéance le {{dueDate}}."
      },
      "byActorNoJobNoAssetLegacy": {
        "title": "Une intervention vous a été assignée",
        "body": "{{actor}} vous a assigné une intervention · échéance le {{dueDate}}."
      },
      "byActorNoJobNoAsset": {
        "title": "Une intervention vous a été assignée",
        "body": "{{actor}} vous a assigné une intervention · échéance le {{dueDate}}."
      },
      "byActor": {
        "title": "Une intervention vous a été assignée",
        "body": "{{actor}} vous a assigné « {{job}} » · {{asset}} · échéance le {{dueDate}}."
      },
      "byActorNoJobNoDueLegacy": {
        "title": "Une intervention vous a été assignée",
        "body": "{{actor}} vous a assigné une intervention · {{asset}}."
      },
      "byActorNoJobNoDue": {
        "title": "Une intervention vous a été assignée",
        "body": "{{actor}} vous a assigné une intervention · {{asset}}."
      },
      "byActorNoAsset": {
        "title": "Une intervention vous a été assignée",
        "body": "{{actor}} vous a assigné « {{job}} » · échéance le {{dueDate}}."
      },
      "byActorNoJobNoAssetNoDueLegacy": {
        "title": "Une intervention vous a été assignée",
        "body": "{{actor}} vous a assigné une intervention."
      },
      "byActorNoJobNoAssetNoDue": {
        "title": "Une intervention vous a été assignée",
        "body": "{{actor}} vous a assigné une intervention."
      },
      "byActorNoDue": {
        "title": "Une intervention vous a été assignée",
        "body": "{{actor}} vous a assigné « {{job}} » · {{asset}}."
      },
      "byActorNoAssetNoDue": {
        "title": "Une intervention vous a été assignée",
        "body": "{{actor}} vous a assigné « {{job}} »."
      },
      "noJob": {
        "title": "Une intervention vous a été assignée",
        "body": "Une intervention · {{asset}} · échéance le {{dueDate}}."
      },
      "noJobNoAsset": {
        "title": "Une intervention vous a été assignée",
        "body": "Une intervention · échéance le {{dueDate}}."
      },
      "default": {
        "title": "Une intervention vous a été assignée",
        "body": "{{job}} · {{asset}} · échéance le {{dueDate}}."
      },
      "noJobNoDue": {
        "title": "Une intervention vous a été assignée",
        "body": "Une intervention · {{asset}}."
      },
      "noAsset": {
        "title": "Une intervention vous a été assignée",
        "body": "{{job}} · échéance le {{dueDate}}."
      },
      "noJobNoAssetNoDue": {
        "title": "Une intervention vous a été assignée",
        "body": "Une intervention."
      },
      "noDue": {
        "title": "Une intervention vous a été assignée",
        "body": "{{job}} · {{asset}}."
      },
      "noAssetNoDue": {
        "title": "Une intervention vous a été assignée",
        "body": "{{job}}."
      }
    },
    "job_cancelled": {
      "noActorNoJobLegacy": {
        "title": "Intervention annulée",
        "body": "Un collègue a annulé une intervention sur {{asset}}."
      },
      "noActorNoJob": {
        "title": "Intervention annulée",
        "body": "Un collègue a annulé une intervention sur {{asset}}."
      },
      "noActorNoJobNoAssetLegacy": {
        "title": "Intervention annulée",
        "body": "Un collègue a annulé une intervention."
      },
      "noActorNoJobNoAsset": {
        "title": "Intervention annulée",
        "body": "Un collègue a annulé une intervention."
      },
      "noActor": {
        "title": "Intervention annulée",
        "body": "Un collègue a annulé « {{job}} » sur {{asset}}."
      },
      "noActorNoAsset": {
        "title": "Intervention annulée",
        "body": "Un collègue a annulé « {{job}} »."
      },
      "noJobLegacy": {
        "title": "Intervention annulée",
        "body": "{{actor}} a annulé une intervention sur {{asset}}."
      },
      "noJob": {
        "title": "Intervention annulée",
        "body": "{{actor}} a annulé une intervention sur {{asset}}."
      },
      "noJobNoAssetLegacy": {
        "title": "Intervention annulée",
        "body": "{{actor}} a annulé une intervention."
      },
      "noJobNoAsset": {
        "title": "Intervention annulée",
        "body": "{{actor}} a annulé une intervention."
      },
      "default": {
        "title": "Intervention annulée",
        "body": "{{actor}} a annulé « {{job}} » sur {{asset}}."
      },
      "noAsset": {
        "title": "Intervention annulée",
        "body": "{{actor}} a annulé « {{job}} »."
      }
    },
    "job_completion_approved": {
      "noRequesterNoJob": {
        "title": "Achèvement approuvé",
        "body": "Le demandeur a approuvé l’achèvement de l’intervention."
      },
      "noRequester": {
        "title": "Achèvement approuvé",
        "body": "Le demandeur a approuvé l’achèvement de {{job}}."
      },
      "noJob": {
        "title": "Achèvement approuvé",
        "body": "{{requester}} a approuvé l’achèvement de l’intervention."
      },
      "default": {
        "title": "Achèvement approuvé",
        "body": "{{requester}} a approuvé l’achèvement de {{job}}."
      }
    },
    "job_declined": {
      "noActorNoJobLegacy": {
        "title": "Intervention refusée — réassignez-la",
        "body": "L’assigné a refusé une intervention. Motif : {{reason}}. Assignez-la à quelqu’un d’autre pour qu’elle avance."
      },
      "noActorNoJob": {
        "title": "Intervention refusée — réassignez-la",
        "body": "L’assigné a refusé une intervention. Motif : {{reason}} Assignez-la à quelqu’un d’autre pour qu’elle avance."
      },
      "noActor": {
        "title": "Intervention refusée — réassignez-la",
        "body": "L’assigné a refusé « {{job}} ». Motif : {{reason}} Assignez-la à quelqu’un d’autre pour qu’elle avance."
      },
      "noActorNoJobNoReasonLegacy": {
        "title": "Intervention refusée — réassignez-la",
        "body": "L’assigné a refusé une intervention. Assignez-la à quelqu’un d’autre pour qu’elle avance."
      },
      "noActorNoJobNoReason": {
        "title": "Intervention refusée — réassignez-la",
        "body": "L’assigné a refusé une intervention. Assignez-la à quelqu’un d’autre pour qu’elle avance."
      },
      "noJobLegacy": {
        "title": "Intervention refusée — réassignez-la",
        "body": "{{actor}} a refusé une intervention. Motif : {{reason}}. Assignez-la à quelqu’un d’autre pour qu’elle avance."
      },
      "noJob": {
        "title": "Intervention refusée — réassignez-la",
        "body": "{{actor}} a refusé une intervention. Motif : {{reason}} Assignez-la à quelqu’un d’autre pour qu’elle avance."
      },
      "noActorNoReason": {
        "title": "Intervention refusée — réassignez-la",
        "body": "L’assigné a refusé « {{job}} ». Assignez-la à quelqu’un d’autre pour qu’elle avance."
      },
      "default": {
        "title": "Intervention refusée — réassignez-la",
        "body": "{{actor}} a refusé « {{job}} ». Motif : {{reason}} Assignez-la à quelqu’un d’autre pour qu’elle avance."
      },
      "noJobNoReasonLegacy": {
        "title": "Intervention refusée — réassignez-la",
        "body": "{{actor}} a refusé une intervention. Assignez-la à quelqu’un d’autre pour qu’elle avance."
      },
      "noJobNoReason": {
        "title": "Intervention refusée — réassignez-la",
        "body": "{{actor}} a refusé une intervention. Assignez-la à quelqu’un d’autre pour qu’elle avance."
      },
      "noReason": {
        "title": "Intervention refusée — réassignez-la",
        "body": "{{actor}} a refusé « {{job}} ». Assignez-la à quelqu’un d’autre pour qu’elle avance."
      }
    },
    "job_message": {
      "photoNoSenderLegacy": {
        "title": "Nouveau message sur une intervention.",
        "body": "Quelqu’un a partagé une photo."
      },
      "photoNoSender": {
        "title": "Nouveau message sur une intervention.",
        "body": "Quelqu’un a partagé une photo."
      },
      "photoLegacy": {
        "title": "Nouveau message sur une intervention.",
        "body": "{{sender}} a partagé une photo."
      },
      "photo": {
        "title": "Nouveau message sur une intervention.",
        "body": "{{sender}} a partagé une photo."
      },
      "emptyUpdateNoSender": {
        "title": "Nouveau message sur une intervention",
        "body": "Quelqu’un : mise à jour"
      },
      "noSender": {
        "title": "Nouveau message sur une intervention",
        "body": "Quelqu’un : {{message}}"
      },
      "emptyUpdate": {
        "title": "Nouveau message sur une intervention",
        "body": "{{sender}} : mise à jour"
      },
      "default": {
        "title": "Nouveau message sur une intervention",
        "body": "{{sender}} : {{message}}"
      }
    },
    "job_reassigned": {
      "noJobLegacy": {
        "title": "Intervention réassignée",
        "body": "Une intervention ne vous est plus assignée."
      },
      "noJob": {
        "title": "Intervention réassignée",
        "body": "Une intervention ne vous est plus assignée."
      },
      "default": {
        "title": "Intervention réassignée",
        "body": "{{job}} ne vous est plus assignée."
      }
    },
    "job_report_shared": {
      "recipientNoSharerNoJobNoAssetLegacy": {
        "title": "Rapport d’intervention prêt",
        "body": "L’équipe a partagé le rapport de fin d’intervention d’une intervention sur un actif."
      },
      "recipientNoSharerNoJobNoAsset": {
        "title": "Rapport d’intervention prêt",
        "body": "L’équipe a partagé le rapport de fin d’intervention d’une intervention sur un actif."
      },
      "recipientNoSharerNoAsset": {
        "title": "Rapport d’intervention prêt",
        "body": "L’équipe a partagé le rapport de fin d’intervention de « {{job}} » sur un actif."
      },
      "recipientNoJobNoAssetLegacy": {
        "title": "Rapport d’intervention prêt",
        "body": "{{sharer}} a partagé le rapport de fin d’intervention d’une intervention sur un actif."
      },
      "recipientNoJobNoAsset": {
        "title": "Rapport d’intervention prêt",
        "body": "{{sharer}} a partagé le rapport de fin d’intervention d’une intervention sur un actif."
      },
      "recipientNoSharerNoJobLegacy": {
        "title": "Rapport d’intervention prêt",
        "body": "L’équipe a partagé le rapport de fin d’intervention d’une intervention sur {{asset}}."
      },
      "recipientNoSharerNoJob": {
        "title": "Rapport d’intervention prêt",
        "body": "L’équipe a partagé le rapport de fin d’intervention d’une intervention sur {{asset}}."
      },
      "recipientNoAsset": {
        "title": "Rapport d’intervention prêt",
        "body": "{{sharer}} a partagé le rapport de fin d’intervention de « {{job}} » sur un actif."
      },
      "recipientNoSharer": {
        "title": "Rapport d’intervention prêt",
        "body": "L’équipe a partagé le rapport de fin d’intervention de « {{job}} » sur {{asset}}."
      },
      "recipientNoJobLegacy": {
        "title": "Rapport d’intervention prêt",
        "body": "{{sharer}} a partagé le rapport de fin d’intervention d’une intervention sur {{asset}}."
      },
      "recipientNoJob": {
        "title": "Rapport d’intervention prêt",
        "body": "{{sharer}} a partagé le rapport de fin d’intervention d’une intervention sur {{asset}}."
      },
      "sharerNoRecipient": {
        "title": "Rapport de fin d’intervention partagé",
        "body": "Lien du rapport envoyé au destinataire."
      },
      "recipient": {
        "title": "Rapport d’intervention prêt",
        "body": "{{sharer}} a partagé le rapport de fin d’intervention de « {{job}} » sur {{asset}}."
      },
      "resentNoRecipient": {
        "title": "Rapport de fin d’intervention renvoyé",
        "body": "Envoyé de nouveau au destinataire."
      },
      "sharer": {
        "title": "Rapport de fin d’intervention partagé",
        "body": "Lien du rapport envoyé à {{recipient}}."
      },
      "sharerBlankName": {
        "title": "Rapport de fin d’intervention partagé",
        "body": "Le lien du rapport est prêt."
      },
      "resentBlankName": {
        "title": "Rapport de fin d’intervention renvoyé",
        "body": "Lien du rapport mis à jour."
      },
      "resent": {
        "title": "Rapport de fin d’intervention renvoyé",
        "body": "Envoyé de nouveau à {{recipient}}."
      }
    },
    "job_requester_accepted": {
      "verifierNoRequesterNoJob": {
        "title": "Le demandeur est satisfait — vérifiez pour clôturer",
        "body": "Le demandeur a accepté l’achèvement de l’intervention. Vérifiez l’intervention pour la clôturer."
      },
      "verifierNoRequester": {
        "title": "Le demandeur est satisfait — vérifiez pour clôturer",
        "body": "Le demandeur a accepté l’achèvement de {{job}}. Vérifiez l’intervention pour la clôturer."
      },
      "verifierNoJob": {
        "title": "Le demandeur est satisfait — vérifiez pour clôturer",
        "body": "{{requester}} a accepté l’achèvement de l’intervention. Vérifiez l’intervention pour la clôturer."
      },
      "verifier": {
        "title": "Le demandeur est satisfait — vérifiez pour clôturer",
        "body": "{{requester}} a accepté l’achèvement de {{job}}. Vérifiez l’intervention pour la clôturer."
      },
      "informedNoRequesterNoJob": {
        "title": "Le demandeur a accepté le travail",
        "body": "Le demandeur a accepté l’achèvement de l’intervention."
      },
      "informedNoRequester": {
        "title": "Le demandeur a accepté le travail",
        "body": "Le demandeur a accepté l’achèvement de {{job}}."
      },
      "informedNoJob": {
        "title": "Le demandeur a accepté le travail",
        "body": "{{requester}} a accepté l’achèvement de l’intervention."
      },
      "informed": {
        "title": "Le demandeur a accepté le travail",
        "body": "{{requester}} a accepté l’achèvement de {{job}}."
      }
    },
    "job_rework_requested": {
      "noRequesterNoJob": {
        "title": "Reprise demandée",
        "body": "Le demandeur a demandé une reprise de l’intervention : {{note}}"
      },
      "noRequesterNoJobNoNote": {
        "title": "Reprise demandée",
        "body": "Le demandeur a demandé une reprise de l’intervention."
      },
      "noRequester": {
        "title": "Reprise demandée",
        "body": "Le demandeur a demandé une reprise sur {{job}} : {{note}}"
      },
      "noRequesterNoNote": {
        "title": "Reprise demandée",
        "body": "Le demandeur a demandé une reprise sur {{job}}."
      },
      "noJob": {
        "title": "Reprise demandée",
        "body": "{{requester}} a demandé une reprise de l’intervention : {{note}}"
      },
      "noJobNoNote": {
        "title": "Reprise demandée",
        "body": "{{requester}} a demandé une reprise de l’intervention."
      },
      "default": {
        "title": "Reprise demandée",
        "body": "{{requester}} a demandé une reprise sur {{job}} : {{note}}"
      },
      "noNote": {
        "title": "Reprise demandée",
        "body": "{{requester}} a demandé une reprise sur {{job}}."
      }
    },
    "job_scheduled": {
      "noActorNoJobLegacy": {
        "title": "Visite planifiée",
        "body": "L’assigné a planifié une intervention le {{when}}."
      },
      "noActorNoJob": {
        "title": "Visite planifiée",
        "body": "L’assigné a planifié une intervention le {{when}}."
      },
      "noActor": {
        "title": "Visite planifiée",
        "body": "L’assigné a planifié « {{job}} » le {{when}}."
      },
      "noJobLegacy": {
        "title": "Visite planifiée",
        "body": "{{actor}} a planifié une intervention le {{when}}."
      },
      "noJob": {
        "title": "Visite planifiée",
        "body": "{{actor}} a planifié une intervention le {{when}}."
      },
      "default": {
        "title": "Visite planifiée",
        "body": "{{actor}} a planifié « {{job}} » le {{when}}."
      }
    },
    "job_unassigned": {
      "noJobLegacy": {
        "title": "Intervention désassignée",
        "body": "Une intervention ne vous est plus assignée."
      },
      "noJob": {
        "title": "Intervention désassignée",
        "body": "Une intervention ne vous est plus assignée."
      },
      "default": {
        "title": "Intervention désassignée",
        "body": "{{job}} ne vous est plus assignée."
      }
    },
    "job_verified": {
      "noActorNoJobLegacy": {
        "title": "Votre travail a été vérifié",
        "body": "Le propriétaire a vérifié une intervention. L’intervention est clôturée."
      },
      "noActorNoJob": {
        "title": "Votre travail a été vérifié",
        "body": "Le propriétaire a vérifié une intervention. L’intervention est clôturée."
      },
      "noActor": {
        "title": "Votre travail a été vérifié",
        "body": "Le propriétaire a vérifié « {{job}} ». L’intervention est clôturée."
      },
      "noJobLegacy": {
        "title": "Votre travail a été vérifié",
        "body": "{{actor}} a vérifié une intervention. L’intervention est clôturée."
      },
      "noJob": {
        "title": "Votre travail a été vérifié",
        "body": "{{actor}} a vérifié une intervention. L’intervention est clôturée."
      },
      "default": {
        "title": "Votre travail a été vérifié",
        "body": "{{actor}} a vérifié « {{job}} ». L’intervention est clôturée."
      }
    },
    "job_visit_proposed": {
      "noJob": {
        "title": "Confirmez l’horaire de la visite",
        "body": "Une intervention est prévue le {{when}} — confirmez que quelqu’un peut être présent, ou demandez un autre horaire."
      },
      "default": {
        "title": "Confirmez l’horaire de la visite",
        "body": "{{job}} est prévue le {{when}} — confirmez que quelqu’un peut être présent, ou demandez un autre horaire."
      }
    },
    "mcp_action_proposed": {
      "oneNoClient": {
        "title": "Demandes de l’IA à approuver",
        "body": "Un assistant IA demande l’autorisation de : {{action}}. Approuvez ou refusez avant l’expiration."
      },
      "many": {
        "title": "Demandes de l’IA à approuver",
        "body": "{{total}} modifications proposées par des assistants IA attendent votre approbation."
      },
      "one": {
        "title": "Demandes de l’IA à approuver",
        "body": "{{client}} demande l’autorisation de : {{action}}. Approuvez ou refusez avant l’expiration."
      }
    },
    "member_removed_reassign": {
      "noLeaverNoJobLegacy": {
        "title": "Réassignez le travail laissé en suspens",
        "body": "Quelqu’un a quitté l’équipe alors qu’une intervention lui était encore assignée. Assignez-la à quelqu’un d’autre."
      },
      "noLeaverNoJob": {
        "title": "Réassignez le travail laissé en suspens",
        "body": "Quelqu’un a quitté l’équipe alors qu’une intervention lui était encore assignée. Assignez-la à quelqu’un d’autre."
      },
      "noLeaver": {
        "title": "Réassignez le travail laissé en suspens",
        "body": "Quelqu’un a quitté l’équipe alors que « {{job}} » lui était encore assignée. Assignez-la à quelqu’un d’autre."
      },
      "noJobLegacy": {
        "title": "Réassignez le travail laissé en suspens",
        "body": "{{leaver}} a quitté l’équipe alors qu’une intervention lui était encore assignée. Assignez-la à quelqu’un d’autre."
      },
      "noJob": {
        "title": "Réassignez le travail laissé en suspens",
        "body": "{{leaver}} a quitté l’équipe alors qu’une intervention lui était encore assignée. Assignez-la à quelqu’un d’autre."
      },
      "default": {
        "title": "Réassignez le travail laissé en suspens",
        "body": "{{leaver}} a quitté l’équipe alors que « {{job}} » lui était encore assignée. Assignez-la à quelqu’un d’autre."
      }
    },
    "mfa_reset_requested": {
      "noMember": {
        "title": "Réinitialisation de la vérification en deux étapes demandée",
        "body": "Un membre de l’espace de travail ne peut plus se connecter avec la vérification en deux étapes et demande une réinitialisation."
      },
      "default": {
        "title": "Réinitialisation de la vérification en deux étapes demandée",
        "body": "{{member}} ne peut plus se connecter avec la vérification en deux étapes et demande une réinitialisation."
      }
    },
    "plan_changed": {
      "byActorLegacy": {
        "title": "Votre plan du {{day}} a changé",
        "body": "{{actor}} a modifié {{total}} éléments de votre journée. Ouvrez Ma journée pour voir les changements."
      },
      "byActor": {
        "title": "Votre plan du {{day}} a changé",
        "body": "{{actor}} a modifié {{total}} éléments de votre journée. Ouvrez Ma journée pour voir les changements."
      },
      "defaultLegacy": {
        "title": "Votre plan du {{day}} a changé",
        "body": "{{total}} éléments de votre journée ont été modifiés. Ouvrez Ma journée pour voir les changements."
      },
      "default": {
        "title": "Votre plan du {{day}} a changé",
        "body": "{{total}} éléments de votre journée ont été modifiés. Ouvrez Ma journée pour voir les changements."
      },
      "byActorOne": {
        "title": "Votre plan du {{day}} a changé",
        "body": "{{actor}} a modifié {{total}} élément de votre journée. Ouvrez Ma journée pour voir le changement."
      },
      "one": {
        "title": "Votre plan du {{day}} a changé",
        "body": "{{total}} élément de votre journée a été modifié. Ouvrez Ma journée pour voir le changement."
      }
    },
    "plan_review": {
      "default": {
        "title": "Le plan du {{day}} est à revoir",
        "body": "Un élément de la journée ne tient plus. Ouvrez le calendrier pour examiner le plan suggéré."
      }
    },
    "quote_declined": {
      "noContractor": {
        "title": "Demande de devis refusée",
        "body": "Un prestataire a refusé de faire un devis pour {{job}}."
      },
      "noContractorNoJob": {
        "title": "Demande de devis refusée",
        "body": "Un prestataire a refusé de faire un devis."
      },
      "default": {
        "title": "Demande de devis refusée",
        "body": "{{contractor}} a refusé de faire un devis pour {{job}}."
      },
      "noJob": {
        "title": "Demande de devis refusée",
        "body": "{{contractor}} a refusé de faire un devis."
      }
    },
    "quote_rejected": {
      "noJobLegacy": {
        "title": "Devis non retenu",
        "body": "Votre devis pour une intervention a été examiné, mais n’a pas été retenu."
      },
      "noJob": {
        "title": "Devis non retenu",
        "body": "Votre devis pour une intervention a été examiné, mais n’a pas été retenu."
      },
      "default": {
        "title": "Devis non retenu",
        "body": "Votre devis pour « {{job}} » a été examiné, mais n’a pas été retenu."
      }
    },
    "quote_requested": {
      "noJobLegacy": {
        "title": "Demande de devis",
        "body": "On vous invite à soumettre un devis pour : une intervention."
      },
      "noJob": {
        "title": "Demande de devis",
        "body": "On vous invite à soumettre un devis pour : une intervention."
      },
      "default": {
        "title": "Demande de devis",
        "body": "On vous invite à soumettre un devis pour : {{job}}."
      }
    },
    "quote_submitted": {
      "taxNoContractorNoJob": {
        "title": "Nouveau devis reçu",
        "body": "Un prestataire propose {{amount}} TTC pour une intervention. Examinez les devis."
      },
      "taxNoContractor": {
        "title": "Nouveau devis reçu",
        "body": "Un prestataire propose {{amount}} TTC pour « {{job}} ». Examinez les devis."
      },
      "taxNoJob": {
        "title": "Nouveau devis reçu",
        "body": "{{contractor}} propose {{amount}} TTC pour une intervention. Examinez les devis."
      },
      "tax": {
        "title": "Nouveau devis reçu",
        "body": "{{contractor}} propose {{amount}} TTC pour « {{job}} ». Examinez les devis."
      },
      "noContractorNoPriceNoJobLegacy": {
        "title": "Nouveau devis reçu",
        "body": "Un prestataire a soumis un devis pour une intervention. Examinez les devis."
      },
      "noContractorNoPriceNoJob": {
        "title": "Nouveau devis reçu",
        "body": "Un prestataire a soumis un devis pour une intervention. Examinez les devis."
      },
      "noContractorNoPrice": {
        "title": "Nouveau devis reçu",
        "body": "Un prestataire a soumis un devis pour « {{job}} ». Examinez les devis."
      },
      "noContractorNoJobLegacy": {
        "title": "Nouveau devis reçu",
        "body": "Un prestataire propose {{amount}} pour une intervention. Examinez les devis."
      },
      "noContractorNoJob": {
        "title": "Nouveau devis reçu",
        "body": "Un prestataire propose {{amount}} pour une intervention. Examinez les devis."
      },
      "noPriceNoJobLegacy": {
        "title": "Nouveau devis reçu",
        "body": "{{contractor}} a soumis un devis pour une intervention. Examinez les devis."
      },
      "noPriceNoJob": {
        "title": "Nouveau devis reçu",
        "body": "{{contractor}} a soumis un devis pour une intervention. Examinez les devis."
      },
      "noContractor": {
        "title": "Nouveau devis reçu",
        "body": "Un prestataire propose {{amount}} pour « {{job}} ». Examinez les devis."
      },
      "noPrice": {
        "title": "Nouveau devis reçu",
        "body": "{{contractor}} a soumis un devis pour « {{job}} ». Examinez les devis."
      },
      "noJobLegacy": {
        "title": "Nouveau devis reçu",
        "body": "{{contractor}} propose {{amount}} pour une intervention. Examinez les devis."
      },
      "noJob": {
        "title": "Nouveau devis reçu",
        "body": "{{contractor}} propose {{amount}} pour une intervention. Examinez les devis."
      },
      "default": {
        "title": "Nouveau devis reçu",
        "body": "{{contractor}} propose {{amount}} pour « {{job}} ». Examinez les devis."
      }
    },
    "report_access_declined": {
      "noAsset": {
        "title": "Accès au rapport refusé",
        "body": "Votre demande de consultation du rapport pour l’actif a été refusée."
      },
      "default": {
        "title": "Accès au rapport refusé",
        "body": "Votre demande de consultation du rapport pour {{asset}} a été refusée."
      }
    },
    "report_access_granted": {
      "noAsset": {
        "title": "Accès au rapport approuvé",
        "body": "Vous pouvez désormais consulter le rapport pour l’actif."
      },
      "default": {
        "title": "Accès au rapport approuvé",
        "body": "Vous pouvez désormais consulter le rapport pour {{asset}}."
      }
    },
    "report_access_requested": {
      "noRequesterNoAsset": {
        "title": "Accès au rapport demandé.",
        "body": "Quelqu’un a demandé à consulter le rapport pour un actif."
      },
      "noAsset": {
        "title": "Accès au rapport demandé.",
        "body": "{{requester}} a demandé à consulter le rapport pour un actif."
      },
      "noRequester": {
        "title": "Accès au rapport demandé.",
        "body": "Quelqu’un a demandé à consulter le rapport pour {{asset}}."
      },
      "default": {
        "title": "Accès au rapport demandé.",
        "body": "{{requester}} a demandé à consulter le rapport pour {{asset}}."
      },
      "noRequesterNoAssetLegacy": {
        "title": "Accès au rapport demandé.",
        "body": "Quelqu’un a demandé à consulter le rapport pour un actif."
      },
      "noAssetLegacy": {
        "title": "Accès au rapport demandé.",
        "body": "{{requester}} a demandé à consulter le rapport pour un actif."
      },
      "noRequesterLegacy": {
        "title": "Accès au rapport demandé.",
        "body": "Quelqu’un a demandé à consulter le rapport pour {{asset}}."
      },
      "defaultLegacy": {
        "title": "Accès au rapport demandé.",
        "body": "{{requester}} a demandé à consulter le rapport pour {{asset}}."
      }
    },
    "request_assigned": {
      "default": {
        "title": "Une demande vous a été assignée",
        "body": "{{request}} attend votre action."
      },
      "byActor": {
        "title": "Une demande vous a été assignée",
        "body": "{{actor}} vous a assigné « {{request}} »."
      }
    },
    "request_reassigned": {
      "default": {
        "title": "Demande réassignée",
        "body": "{{request}} ne vous est plus assignée."
      }
    },
    "request_team_assigned": {
      "noTeam": {
        "title": "Demande transférée à votre équipe",
        "body": "{{request}} est désormais gérée par votre équipe."
      },
      "default": {
        "title": "Demande transférée à votre équipe",
        "body": "{{request}} est désormais gérée par {{team}}."
      }
    },
    "request_team_removed": {
      "default": {
        "title": "Demande transférée hors de votre équipe",
        "body": "{{request}} n’est plus gérée par votre équipe."
      }
    },
    "rework_requested": {
      "noActorNoJobLegacy": {
        "title": "Reprise nécessaire sur votre intervention",
        "body": "Le vérificateur a renvoyé une intervention pour reprise. Motif : {{reason}}."
      },
      "noActorNoJob": {
        "title": "Reprise nécessaire sur votre intervention",
        "body": "Le vérificateur a renvoyé une intervention pour reprise. Motif : {{reason}}"
      },
      "noActor": {
        "title": "Reprise nécessaire sur votre intervention",
        "body": "Le vérificateur a renvoyé « {{job}} » pour reprise. Motif : {{reason}}"
      },
      "noActorNoJobNoReasonLegacy": {
        "title": "Reprise nécessaire sur votre intervention",
        "body": "Le vérificateur a renvoyé une intervention pour reprise."
      },
      "noActorNoJobNoReason": {
        "title": "Reprise nécessaire sur votre intervention",
        "body": "Le vérificateur a renvoyé une intervention pour reprise."
      },
      "noJobLegacy": {
        "title": "Reprise nécessaire sur votre intervention",
        "body": "{{actor}} a renvoyé une intervention pour reprise. Motif : {{reason}}."
      },
      "noJob": {
        "title": "Reprise nécessaire sur votre intervention",
        "body": "{{actor}} a renvoyé une intervention pour reprise. Motif : {{reason}}"
      },
      "noActorNoReason": {
        "title": "Reprise nécessaire sur votre intervention",
        "body": "Le vérificateur a renvoyé « {{job}} » pour reprise."
      },
      "default": {
        "title": "Reprise nécessaire sur votre intervention",
        "body": "{{actor}} a renvoyé « {{job}} » pour reprise. Motif : {{reason}}"
      },
      "noJobNoReasonLegacy": {
        "title": "Reprise nécessaire sur votre intervention",
        "body": "{{actor}} a renvoyé une intervention pour reprise."
      },
      "noJobNoReason": {
        "title": "Reprise nécessaire sur votre intervention",
        "body": "{{actor}} a renvoyé une intervention pour reprise."
      },
      "noReason": {
        "title": "Reprise nécessaire sur votre intervention",
        "body": "{{actor}} a renvoyé « {{job}} » pour reprise."
      }
    },
    "share_message": {
      "noSender": {
        "title": "Nouveau message sur un rapport d’inspection",
        "body": "Quelqu’un : {{message}}"
      },
      "default": {
        "title": "Nouveau message sur un rapport d’inspection",
        "body": "{{sender}} : {{message}}"
      }
    },
    "share_response_submitted": {
      "closedOnBehalfNoActorNoRecipient": {
        "title": "Rapport clôturé sans réponse",
        "body": "L’équipe de l’actif a clôturé le rapport pour {{asset}} au nom du destinataire : {{reason}}"
      },
      "closedOnBehalfNoActorNoRecipientNoReason": {
        "title": "Rapport clôturé sans réponse",
        "body": "L’équipe de l’actif a clôturé le rapport pour {{asset}} au nom du destinataire."
      },
      "approvedOnBehalfNoActorNoRecipient": {
        "title": "Rapport d’inspection approuvé",
        "body": "L’équipe de l’actif a validé le rapport pour {{asset}} au nom du destinataire."
      },
      "closedOnBehalfNoActorNoAssetNoRecipient": {
        "title": "Rapport clôturé sans réponse",
        "body": "L’équipe de l’actif a clôturé le rapport au nom du destinataire : {{reason}}"
      },
      "closedOnBehalfNoActorNoAssetNoRecipientNoReason": {
        "title": "Rapport clôturé sans réponse",
        "body": "L’équipe de l’actif a clôturé le rapport au nom du destinataire."
      },
      "approvedOnBehalfNoActorNoAssetNoRecipient": {
        "title": "Rapport d’inspection approuvé",
        "body": "L’équipe de l’actif a validé le rapport au nom du destinataire."
      },
      "closedOnBehalfNoActor": {
        "title": "Rapport clôturé sans réponse",
        "body": "L’équipe de l’actif a clôturé le rapport pour {{asset}} au nom de {{recipient}} : {{reason}}"
      },
      "closedOnBehalfNoRecipient": {
        "title": "Rapport clôturé sans réponse",
        "body": "{{actor}} a clôturé le rapport pour {{asset}} au nom du destinataire : {{reason}}"
      },
      "closedOnBehalfNoActorNoReason": {
        "title": "Rapport clôturé sans réponse",
        "body": "L’équipe de l’actif a clôturé le rapport pour {{asset}} au nom de {{recipient}}."
      },
      "closedOnBehalfNoRecipientNoReason": {
        "title": "Rapport clôturé sans réponse",
        "body": "{{actor}} a clôturé le rapport pour {{asset}} au nom du destinataire."
      },
      "approvedOnBehalfNoActor": {
        "title": "Rapport d’inspection approuvé",
        "body": "L’équipe de l’actif a validé le rapport pour {{asset}} au nom de {{recipient}}."
      },
      "changesNoSigner": {
        "title": "Modifications demandées sur un rapport",
        "body": "Le destinataire a demandé des modifications du rapport pour {{asset}} : {{reason}}"
      },
      "approvedOnBehalfNoRecipient": {
        "title": "Rapport d’inspection approuvé",
        "body": "{{actor}} a validé le rapport pour {{asset}} au nom du destinataire."
      },
      "changesNoSignerNoReason": {
        "title": "Modifications demandées sur un rapport",
        "body": "Le destinataire a demandé des modifications du rapport pour {{asset}}."
      },
      "closedOnBehalfNoActorNoAsset": {
        "title": "Rapport clôturé sans réponse",
        "body": "L’équipe de l’actif a clôturé le rapport au nom de {{recipient}} : {{reason}}"
      },
      "closedOnBehalfNoAssetNoRecipient": {
        "title": "Rapport clôturé sans réponse",
        "body": "{{actor}} a clôturé le rapport au nom du destinataire : {{reason}}"
      },
      "closedOnBehalfNoActorNoAssetNoReason": {
        "title": "Rapport clôturé sans réponse",
        "body": "L’équipe de l’actif a clôturé le rapport au nom de {{recipient}}."
      },
      "closedOnBehalfNoAssetNoRecipientNoReason": {
        "title": "Rapport clôturé sans réponse",
        "body": "{{actor}} a clôturé le rapport au nom du destinataire."
      },
      "approvedOnBehalfNoActorNoAsset": {
        "title": "Rapport d’inspection approuvé",
        "body": "L’équipe de l’actif a validé le rapport au nom de {{recipient}}."
      },
      "changesNoSignerNoAsset": {
        "title": "Modifications demandées sur un rapport",
        "body": "Le destinataire a demandé des modifications du rapport : {{reason}}"
      },
      "approvedOnBehalfNoAssetNoRecipient": {
        "title": "Rapport d’inspection approuvé",
        "body": "{{actor}} a validé le rapport au nom du destinataire."
      },
      "changesNoSignerNoAssetNoReason": {
        "title": "Modifications demandées sur un rapport",
        "body": "Le destinataire a demandé des modifications du rapport."
      },
      "closedOnBehalf": {
        "title": "Rapport clôturé sans réponse",
        "body": "{{actor}} a clôturé le rapport pour {{asset}} au nom de {{recipient}} : {{reason}}"
      },
      "closedOnBehalfNoReason": {
        "title": "Rapport clôturé sans réponse",
        "body": "{{actor}} a clôturé le rapport pour {{asset}} au nom de {{recipient}}."
      },
      "changes": {
        "title": "Modifications demandées sur un rapport",
        "body": "{{signer}} a demandé des modifications du rapport pour {{asset}} : {{reason}}"
      },
      "approvedNoSigner": {
        "title": "Rapport d’inspection approuvé",
        "body": "Le destinataire a validé le rapport pour {{asset}}."
      },
      "approvedOnBehalf": {
        "title": "Rapport d’inspection approuvé",
        "body": "{{actor}} a validé le rapport pour {{asset}} au nom de {{recipient}}."
      },
      "changesNoReason": {
        "title": "Modifications demandées sur un rapport",
        "body": "{{signer}} a demandé des modifications du rapport pour {{asset}}."
      },
      "closedOnBehalfNoAsset": {
        "title": "Rapport clôturé sans réponse",
        "body": "{{actor}} a clôturé le rapport au nom de {{recipient}} : {{reason}}"
      },
      "closedOnBehalfNoAssetNoReason": {
        "title": "Rapport clôturé sans réponse",
        "body": "{{actor}} a clôturé le rapport au nom de {{recipient}}."
      },
      "changesNoAsset": {
        "title": "Modifications demandées sur un rapport",
        "body": "{{signer}} a demandé des modifications du rapport : {{reason}}"
      },
      "approvedNoSignerNoAsset": {
        "title": "Rapport d’inspection approuvé",
        "body": "Le destinataire a validé le rapport."
      },
      "approvedOnBehalfNoAsset": {
        "title": "Rapport d’inspection approuvé",
        "body": "{{actor}} a validé le rapport au nom de {{recipient}}."
      },
      "changesNoAssetNoReason": {
        "title": "Modifications demandées sur un rapport",
        "body": "{{signer}} a demandé des modifications du rapport."
      },
      "approved": {
        "title": "Rapport d’inspection approuvé",
        "body": "{{signer}} a validé le rapport pour {{asset}}."
      },
      "approvedNoAsset": {
        "title": "Rapport d’inspection approuvé",
        "body": "{{signer}} a validé le rapport."
      }
    },
    "site_team_assigned": {
      "noTeam": {
        "title": "Nouveau site dans votre équipe",
        "body": "{{site}} a été assigné à votre équipe."
      },
      "default": {
        "title": "Nouveau site dans votre équipe",
        "body": "{{site}} a été assigné à {{team}}."
      }
    },
    "site_team_removed": {
      "default": {
        "title": "Site déplacé hors de votre équipe",
        "body": "{{site}} n’est plus assigné à votre équipe."
      }
    },
    "stalled_work_digest": {
      "many": {
        "title": "{{total}} éléments attendent quelqu’un",
        "body": "{{itemTitle}} · {{asset}}. {{line}} Et {{moreCount}} autres."
      },
      "manyNoAsset": {
        "title": "{{total}} éléments attendent quelqu’un",
        "body": "{{itemTitle}}. {{line}} Et {{moreCount}} autres."
      },
      "one": {
        "title": "Un élément attend quelqu’un",
        "body": "{{itemTitle}} · {{asset}}. {{line}}"
      },
      "oneNoAsset": {
        "title": "Un élément attend quelqu’un",
        "body": "{{itemTitle}}. {{line}}"
      }
    },
    "team_admin_approved": {
      "noMemberLegacy": {
        "title": "Un membre de l’équipe est désormais administrateur",
        "body": "Le propriétaire a approuvé votre demande pour un membre de l’équipe."
      },
      "noMember": {
        "title": "Un membre de l’équipe est désormais administrateur",
        "body": "Le propriétaire a approuvé votre demande pour un membre de l’équipe."
      },
      "default": {
        "title": "{{member}} est désormais administrateur",
        "body": "Le propriétaire a approuvé votre demande pour {{member}}."
      }
    },
    "team_admin_declined": {
      "noMemberLegacy": {
        "title": "Demande de droits d’administrateur refusée",
        "body": "Le propriétaire a refusé votre demande de nommer un membre de l’équipe administrateur."
      },
      "noMember": {
        "title": "Demande de droits d’administrateur refusée",
        "body": "Le propriétaire a refusé votre demande de nommer un membre de l’équipe administrateur."
      },
      "default": {
        "title": "Demande de droits d’administrateur refusée",
        "body": "Le propriétaire a refusé votre demande de nommer {{member}} administrateur."
      }
    },
    "team_admin_requested": {
      "noMemberNoTeamLegacy": {
        "title": "Nommer un membre de l’équipe administrateur ?",
        "body": "Votre équipe : un administrateur propose de nommer un membre de l’équipe administrateur."
      },
      "noMemberNoTeam": {
        "title": "Nommer un membre de l’équipe administrateur ?",
        "body": "Votre équipe : un administrateur propose de nommer un membre de l’équipe administrateur."
      },
      "noMemberLegacy": {
        "title": "Nommer un membre de l’équipe administrateur ?",
        "body": "{{team}} : un administrateur propose de nommer un membre de l’équipe administrateur."
      },
      "noMember": {
        "title": "Nommer un membre de l’équipe administrateur ?",
        "body": "{{team}} : un administrateur propose de nommer un membre de l’équipe administrateur."
      },
      "noTeam": {
        "title": "Nommer {{member}} administrateur ?",
        "body": "Votre équipe : un administrateur propose de nommer {{member}} administrateur."
      },
      "default": {
        "title": "Nommer {{member}} administrateur ?",
        "body": "{{team}} : un administrateur propose de nommer {{member}} administrateur."
      }
    },
    "team_invite_accepted": {
      "noTeam": {
        "title": "Invitation à l’espace de travail acceptée",
        "body": "{{email}} a accepté l’invitation à rejoindre votre équipe."
      },
      "default": {
        "title": "Invitation à l’espace de travail acceptée",
        "body": "{{email}} a accepté l’invitation à rejoindre {{team}}."
      }
    },
    "team_invite_declined": {
      "noTeam": {
        "title": "Invitation à l’espace de travail refusée",
        "body": "{{email}} a refusé l’invitation à rejoindre votre équipe."
      },
      "default": {
        "title": "Invitation à l’espace de travail refusée",
        "body": "{{email}} a refusé l’invitation à rejoindre {{team}}."
      }
    },
    "team_invited": {
      "noTeam": {
        "title": "Invitation à l’espace de travail",
        "body": "Vous avez reçu une invitation à rejoindre une équipe de l’espace de travail."
      },
      "default": {
        "title": "Invitation à l’espace de travail",
        "body": "Vous avez reçu une invitation à rejoindre {{team}}."
      }
    },
    "team_member_added": {
      "noTeam": {
        "title": "Ajout à une équipe de l’espace de travail",
        "body": "Votre équipe."
      },
      "default": {
        "title": "Ajout à une équipe de l’espace de travail",
        "body": "{{team}}."
      }
    },
    "team_member_removed": {
      "noTeam": {
        "title": "Retrait d’une équipe de l’espace de travail",
        "body": "Votre équipe."
      },
      "default": {
        "title": "Retrait d’une équipe de l’espace de travail",
        "body": "{{team}}."
      }
    },
    "team_member_role_changed": {
      "noTeam": {
        "title": "Rôle dans l’espace de travail modifié",
        "body": "Votre équipe · rôle : {{role}}"
      },
      "default": {
        "title": "Rôle dans l’espace de travail modifié",
        "body": "{{team}} · rôle : {{role}}"
      }
    },
    "team_ownership_accepted": {
      "noWorkspace": {
        "title": "Transfert de propriété de l’espace de travail accepté",
        "body": "Le transfert de propriété de l’espace de travail a été accepté."
      },
      "default": {
        "title": "Transfert de propriété de l’espace de travail accepté",
        "body": "Le transfert de propriété de {{workspace}} a été accepté."
      }
    },
    "team_ownership_cancelled": {
      "noWorkspace": {
        "title": "Transfert de propriété de l’espace de travail annulé",
        "body": "Le transfert de propriété de l’espace de travail a été annulé."
      },
      "default": {
        "title": "Transfert de propriété de l’espace de travail annulé",
        "body": "Le transfert de propriété de {{workspace}} a été annulé."
      }
    },
    "team_ownership_declined": {
      "noWorkspace": {
        "title": "Transfert de propriété de l’espace de travail refusé",
        "body": "Le transfert de propriété de l’espace de travail a été refusé."
      },
      "default": {
        "title": "Transfert de propriété de l’espace de travail refusé",
        "body": "Le transfert de propriété de {{workspace}} a été refusé."
      }
    },
    "team_ownership_expired": {
      "noWorkspaceLegacy": {
        "title": "Transfert de propriété de l’espace de travail expiré",
        "body": "Le transfert de propriété de l’espace de travail a expiré."
      },
      "noWorkspace": {
        "title": "Transfert de propriété de l’espace de travail expiré",
        "body": "Le transfert de propriété de l’espace de travail a expiré."
      },
      "defaultLegacy": {
        "title": "Transfert de propriété de l’espace de travail expiré",
        "body": "Le transfert de propriété de {{workspace}} a expiré."
      },
      "default": {
        "title": "Transfert de propriété de l’espace de travail expiré",
        "body": "Le transfert de propriété de {{workspace}} a expiré."
      }
    },
    "team_ownership_requested": {
      "noWorkspace": {
        "title": "Propriété de l’espace de travail proposée",
        "body": "Un espace de travail attend votre décision."
      },
      "default": {
        "title": "Propriété de l’espace de travail proposée",
        "body": "{{workspace}} attend votre décision."
      }
    },
    "work_change_approved": {
      "byPolicyNoWork": {
        "title": "Ignoré selon la règle du plan : travail planifié",
        "body": "{{reason}}"
      },
      "byPolicy": {
        "title": "Ignoré selon la règle du plan : {{work}}",
        "body": "{{reason}}"
      },
      "decided": {
        "title": "Modification approuvée",
        "body": "Accord donné pour {{action}}"
      }
    },
    "work_change_rejected": {
      "default": {
        "title": "Modification non approuvée",
        "body": "Ce travail reste dû"
      }
    },
    "work_change_requested": {
      "noWork": {
        "title": "Modification demandée : travail planifié",
        "body": "{{reason}}"
      },
      "default": {
        "title": "Modification demandée : {{work}}",
        "body": "{{reason}}"
      }
    },
    "work_needs_assignee": {
      "raisedNoAsset": {
        "title": "Personne n’est encore affecté",
        "body": "\"{{work}}\" est à faire pour le {{dueDate}}. Affectez quelqu’un d’ici là."
      },
      "reminderNoAsset": {
        "title": "Toujours personne d’affecté",
        "body": "\"{{work}}\" est à faire pour le {{dueDate}}. Affectez quelqu’un ou faites-le vous-même."
      },
      "raised": {
        "title": "Personne n’est encore affecté",
        "body": "\"{{work}}\" · {{asset}} est à faire pour le {{dueDate}}. Affectez quelqu’un d’ici là."
      },
      "reminder": {
        "title": "Toujours personne d’affecté",
        "body": "\"{{work}}\" · {{asset}} est à faire pour le {{dueDate}}. Affectez quelqu’un ou faites-le vous-même."
      }
    },
    "work_rescheduled": {
      "noInspection": {
        "title": "Reprogrammation",
        "body": "Une inspection · {{asset}} est désormais prévue le {{when}}."
      },
      "noInspectionNoAsset": {
        "title": "Reprogrammation",
        "body": "L’inspection est désormais prévue le {{when}}."
      },
      "noJob": {
        "title": "Reprogrammation",
        "body": "Une intervention · {{asset}} est désormais prévue le {{when}}."
      },
      "noJobNoAsset": {
        "title": "Reprogrammation",
        "body": "Une intervention est désormais prévue le {{when}}."
      },
      "default": {
        "title": "Reprogrammation",
        "body": "{{work}} · {{asset}} est désormais prévue le {{when}}."
      },
      "noAsset": {
        "title": "Reprogrammation",
        "body": "{{work}} est désormais prévue le {{when}}."
      }
    },
    "work_unscheduled": {
      "noInspection": {
        "title": "Retiré du planning",
        "body": "Une inspection · {{asset}} n’est plus planifiée."
      },
      "noInspectionNoAsset": {
        "title": "Retiré du planning",
        "body": "L’inspection n’est plus planifiée."
      },
      "noJob": {
        "title": "Retiré du planning",
        "body": "Une intervention · {{asset}} n’est plus planifiée."
      },
      "noJobNoAsset": {
        "title": "Retiré du planning",
        "body": "Une intervention n’est plus planifiée."
      },
      "default": {
        "title": "Retiré du planning",
        "body": "{{work}} · {{asset}} n’est plus planifiée."
      },
      "noAsset": {
        "title": "Retiré du planning",
        "body": "{{work}} n’est plus planifiée."
      }
    },
    "esg_certificate_expiring": {
      "expired": {
        "title": "Certificat énergétique expiré : {{place}}",
        "body": "Le {{scheme}} (classe {{rating}}) expire le {{endDate}}. Réservez un nouveau diagnostic pour pouvoir louer ou vendre."
      },
      "inDays": {
        "title": "Le certificat énergétique expire dans {{daysLeft}} jours : {{place}}",
        "body": "Le {{scheme}} (classe {{rating}}) expire le {{endDate}}. Réservez un nouveau diagnostic pour pouvoir louer ou vendre."
      }
    }
  },
  "lines": {
    "shareNotAcceptedOne": "Accès à cet actif non accepté par {{waitingOn}} depuis {{days}} jour. Relancez ou retirez le partage.",
    "shareNotAccepted": "Accès à cet actif non accepté par {{waitingOn}} depuis {{days}} jours. Relancez ou retirez le partage.",
    "expiredNotRenewedOne": "Expiré depuis {{days}} jour, et personne ne l’a renouvelé.",
    "expiredNotRenewed": "Expiré depuis {{days}} jours, et personne ne l’a renouvelé.",
    "fixNotConfirmedOne": "Correctif non confirmé par {{waitingOn}} depuis {{days}} jour. Relancez.",
    "fixNotConfirmed": "Correctif non confirmé par {{waitingOn}} depuis {{days}} jours. Relancez.",
    "notRedoneOne": "Reprise non effectuée par {{waitingOn}} depuis {{days}} jour. Relancez ou réassignez.",
    "notRedone": "Reprise non effectuée par {{waitingOn}} depuis {{days}} jours. Relancez ou réassignez.",
    "inviteNotAcceptedOne": "Invitation non acceptée par {{waitingOn}} depuis {{days}} jour. Renvoyez-la ou retirez-la.",
    "inviteNotAccepted": "Invitation non acceptée par {{waitingOn}} depuis {{days}} jours. Renvoyez-la ou retirez-la.",
    "approvedNoWorkOne": "Approbation donnée il y a {{days}} jour, mais aucun travail n’a encore été créé.",
    "approvedNoWork": "Approbation donnée il y a {{days}} jours, mais aucun travail n’a encore été créé.",
    "overdueOne": "Échéance dépassée depuis {{days}} jour, et ce n’est toujours pas fait.",
    "overdue": "Échéance dépassée depuis {{days}} jours, et ce n’est toujours pas fait.",
    "overdueUnassignedOne": "Échéance dépassée depuis {{days}} jour, et personne n’en est chargé. Assignez quelqu’un ou faites-le vous-même.",
    "overdueUnassigned": "Échéance dépassée depuis {{days}} jours, et personne n’en est chargé. Assignez quelqu’un ou faites-le vous-même.",
    "overdueNotDoneOne": "Échéance dépassée depuis {{days}} jour, et {{waitingOn}} ne l’a pas fait. Réassignez ou faites-le vous-même.",
    "overdueNotDone": "Échéance dépassée depuis {{days}} jours, et {{waitingOn}} ne l’a pas fait. Réassignez ou faites-le vous-même.",
    "quotesStalledOne": "Rien n’a bougé sur ces devis depuis {{days}} jour. Attribuez-en un, relancez ou fixez une date limite.",
    "quotesStalled": "Rien n’a bougé sur ces devis depuis {{days}} jours. Attribuez-en un, relancez ou fixez une date limite.",
    "awaitingYourValidationOne": "En attente de votre validation depuis {{days}} jour.",
    "awaitingYourValidation": "En attente de votre validation depuis {{days}} jours.",
    "quoteDeadlinePassedOne": "La date limite des devis est dépassée depuis {{days}} jour. Attribuez-en un, relancez ou fixez une nouvelle date.",
    "quoteDeadlinePassed": "La date limite des devis est dépassée depuis {{days}} jours. Attribuez-en un, relancez ou fixez une nouvelle date.",
    "awaitingYourPickupOne": "En attente de votre prise en charge depuis {{days}} jour.",
    "awaitingYourPickup": "En attente de votre prise en charge depuis {{days}} jours.",
    "awaitingYourApprovalOne": "En attente de votre approbation depuis {{days}} jour.",
    "awaitingYourApproval": "En attente de votre approbation depuis {{days}} jours.",
    "noResponseOne": "Aucune réponse donnée par {{waitingOn}} depuis {{days}} jour.",
    "noResponse": "Aucune réponse donnée par {{waitingOn}} depuis {{days}} jours.",
    "notValidatedOne": "En attente de validation par {{waitingOn}} depuis {{days}} jour.",
    "notValidated": "En attente de validation par {{waitingOn}} depuis {{days}} jours.",
    "inviteNotAnsweredOne": "Invitation laissée sans réponse par {{waitingOn}} depuis {{days}} jour. Relancez ou assignez quelqu’un d’autre.",
    "inviteNotAnswered": "Invitation laissée sans réponse par {{waitingOn}} depuis {{days}} jours. Relancez ou assignez quelqu’un d’autre.",
    "notRepliedOne": "Message laissé sans réponse par {{waitingOn}} depuis {{days}} jour.",
    "notReplied": "Message laissé sans réponse par {{waitingOn}} depuis {{days}} jours.",
    "notApprovedOne": "En attente d’approbation par {{waitingOn}} depuis {{days}} jour.",
    "notApproved": "En attente d’approbation par {{waitingOn}} depuis {{days}} jours."
  },
  "values": {
    "featureStatus": {
      "under_review": "en cours d'examen",
      "planned": "prévue",
      "in_progress": "en cours de développement",
      "shipped": "disponible dans l'application",
      "not_planned": "non prévue pour l'instant",
      "considering": "à l'étude"
    },
    "reason": {
      "fault": "panne",
      "end_of_life": "fin de vie",
      "replaced": "remplacé",
      "seasonal": "saisonnier",
      "relocated": "déplacé",
      "decommissioned": "désaffecté",
      "sold": "vendu",
      "disposed": "mis au rebut",
      "lost": "perdu",
      "other": "autre"
    },
    "period": {
      "am": "matin",
      "pm": "après-midi"
    },
    "periodLabel": {
      "morning": "matin",
      "afternoon": "après-midi"
    },
    "documentType": {
      "certificate": "ce certificat",
      "warranty": "cette garantie",
      "compliance_document": "ce document de conformité",
      "document": "ce document"
    },
    "role": {
      "owner": "propriétaire",
      "admin": "administrateur",
      "member": "membre"
    },
    "action": {
      "skip": "ignorer cette occurrence",
      "reschedule": "reporter",
      "reassign": "confier à quelqu’un d’autre"
    },
    "itemTitle": {
      "inspection": "Inspection",
      "job": "Intervention",
      "document": "Document",
      "request": "Demande",
      "scheduled_inspection": "Inspection planifiée",
      "invitation_to_the_team": "Invitation à rejoindre l’équipe"
    },
    "waitingOn": {
      "the_recipient": "le destinataire",
      "asset_approver": "l’approbateur de l’actif",
      "the_approver": "l’approbateur",
      "the_requester": "le demandeur",
      "the_assignee": "l’assigné",
      "the_validator": "le validateur",
      "the_team": "l’équipe",
      "the_contractors_you_asked": "les prestataires sollicités",
      "the_contractor": "le prestataire",
      "the_invitee": "la personne invitée",
      "nobody": "personne",
      "The_recipient": "le destinataire",
      "The_approver": "l’approbateur",
      "The_requester": "le demandeur",
      "The_assignee": "l’assigné",
      "The_validator": "le validateur",
      "The_team": "l’équipe",
      "The_contractor": "le prestataire",
      "The_invitee": "la personne invitée"
    }
  }
};
